// Русская локаль интерфейса. Ключи сгруппированы по экранам; общие подписи — в `common`.
// Добавляя строку — добавляйте её и в en.js (иначе игрок увидит английский фолбэк).
export default {
  common: {
    ok: 'ОК',
    back: 'Назад',
    close: 'Закрыть',
    cancel: 'Отмена',
    later: 'Позже',
    save: 'Сохранить',
    loading: 'Загрузка…',
    energy: 'Энергия',
    rating: 'Рейтинг',
    tickets: 'Билеты',
    materials: 'Материалы',
    gems: 'Самоцветы',
    player: 'Игрок',
    place: 'Место',
    you: 'вы',
    skip: 'Пропустить',
    on: 'вкл',
    off: 'выкл',
    networkError: 'Сеть недоступна. Проверьте соединение.',
  },
  menu: {
    campaign: 'Новая кампания',
    campaignSoon: 'в разработке',
    pvp: 'PVP',
    daily: 'Задания дня',
    tournaments: 'Турниры',
    options: 'Настройки',
    profile: 'Профиль',
    wiki: 'Справка',
  },
  options: {
    title: 'Настройки',
    subtitle: 'Язык интерфейса и параметры игры',
    languageTitle: 'Язык',
    languageHint: 'Интерфейс, подсказки и сообщения игры переключатся сразу — выбор сохранится на этом устройстве.',
    languageAuto: 'Определён по языку устройства',
    languageSaved: 'Язык сохранён',
    soon: 'Скоро',
    soundTitle: 'Звук',
    soundHint: 'Настройки звука появятся в следующем обновлении.',
  },
  app: {
    build: 'сборка',
    rotatePhone: 'Поверните телефон в горизонтальное положение',
    updateAvailable: 'Доступно обновление игры — применится после возврата в лобби.',
    preloading: 'Загрузка контента игры…',
    maintenance: 'Проводятся технические работы,',
    maintenanceSorry: 'приносим извинения за неудобства.',
    maintenanceIn: 'Через',
    maintenanceBanner: '{when} будут производиться технические работы, просьба завершить партии до их начала.',
    seasonBanner: '🏆 Турнир: {title}',
    seasonExit: 'Выйти в основной аккаунт',
    tourStartIn: 'Старт через',
    tourEndsIn: 'До конца турнира',
    tourClaimUntil: 'Забрать награды до',
    greyList: 'Аккаунт в сером списке.\nСледим за вашей активностью.',
    blackList: 'Аккаунт в чёрном списке. Награды не начисляются.\nДля решения вопроса обратитесь в службу поддержки.',
  },
  time: {
    d: 'д',
    h: 'ч',
    m: 'м',
    s: 'с',
    min: 'мин',
  },
  profile: {
    connectWallet: 'подключить кошелёк',
    settingsFigures: 'Настройки фигур',
    wheel: 'Колесо фортуны',
    market: 'Рынок',
    starsShop: 'Магазин ⭐',
    tournaments: 'Турниры',
    logout: 'Выйти',
    changePassword: 'Сменить пароль',
    pwdOld: 'Текущий пароль',
    pwdNew: 'Новый пароль',
    pwdChanged: 'Пароль изменён',
    pwdHint: 'После смены все другие входы в аккаунт (включая турнирные) будут завершены.',
    tgLink: 'Привязать Telegram',
    tgLinked: 'Telegram привязан — теперь вход в игру из мини-приложения будет сразу, без пароля.',
    tgLinkFailed: 'Не удалось привязать Telegram. Попробуйте открыть игру из Telegram заново.',
    tgSwitch: 'У меня уже есть аккаунт в игре',
    tgUnlink: 'Отвязать Telegram',
    tgUnlinked: 'Telegram отвязан. Теперь его можно привязать к другому вашему аккаунту.',
    tgAppHint: 'Привязка идёт через наше мини-приложение в Telegram: ссылка ниже откроет его в вашем Telegram и привяжет аккаунт.',
    tgOpenApp: 'Открыть мини-приложение',
    tgCodeHint: 'Ссылка действует 10 минут. Откройте её на телефоне или в приложении Telegram — аккаунт привяжется сам.',
    tgCodeFailed: 'Ссылка привязки не сработала: срок действия истёк или её уже использовали. Возьмите новую в профиле.',
    statistic: 'Статистика игрока',
    totalGames: 'Всего партий',
    wins: 'Победы',
    loses: 'Поражения',
    energyTotal: 'Всего энергии получено',
    nft: 'NFT-воины',
    nftConnect: 'Подключите кошелёк TON, чтобы увидеть своих NFT-воинов.',
    nftAll: 'Все',
    nftNoneInFilter: 'У этой фракции фигур нет.',
    nftInArmy: 'в строю',
    nftInArmyFull: 'Эта фигура стоит в вашей расстановке',
    nftOnBench: 'Фигура заведена в игре и ждёт в запасе со своей амуницией',
    nftNoStats: 'Статы этой фигуры пока недоступны.',
    nftStatsWithAmmo: 'Статы в игре, с учётом надетой амуниции ({n} предм.)',
    nftStatsNoAmmo: 'Статы в игре: амуниция не надета',
    nftStatsPreview: 'Статы фигуры при вводе в игру (без амуниции)',
    nftEmpty: 'На кошельке нет фигур из нашей коллекции.',
    walletWait: 'подтвердите в кошельке…',
    walletBalance: 'Баланс $ENRG: {n}',
    walletBalanceHint: 'Токены $ENRG на привязанном кошельке',
    walletRefresh: 'Обновить данные с блокчейна',
    dataAgeMin: 'данные {n} мин назад',
    dataAgeHour: 'данные {n} ч назад',
    walletRetry: 'Повторить',
    walletUnlink: 'Отвязать',
    unlinkTitle: 'Отвязать кошелёк?',
    unlinkWarn: 'NFT-фигуры ({n}) уйдут из игры — на их места в составе вернутся ваши фигуры.',
    unlinkGear: 'Их амуниция и вещи из инвентаря вернутся в сундук. Запечённая амуниция останется на NFT и вернётся вместе с ней.',
    unlinkOk: 'Отвязать',
    unlinkDone: 'Кошелёк отвязан. Фигур убрано: {u}, вещей вернулось в сундук: {n}.',
    walletNoProof: 'Кошелёк не подтвердил владение. Попробуйте другой кошелёк или обновите приложение.',
    walletBusy: 'Кошелёк ещё держит прежнее подключение. Закройте приложение кошелька и нажмите снова.',
    walletTimeout: 'Подтверждения из кошелька мы не дождались. Попробуйте ещё раз.',
    walletCancelled: 'Подключение не завершено — попробуйте ещё раз.',
    bakeOk: 'Запечь комплект',
    bakeTitle: 'Запечь комплект?',
    bakeWarn: 'Комплект закрепится за NFT: снять, надеть на другую фигуру, продать, разобрать и отдать автоподбору его будет нельзя. При продаже фигуры вещи уйдут покупателю.',
    bakePrice: 'Цена: {n} энергии из баланса. Разблокировка бесплатна.',
    bakeNoGear: 'На фигуре нет амуниции — запекать нечего',
    bakeStepPaid: 'Оплата',
    bakeStepKit: 'Комплект закреплён за NFT',
    bakeStepFree: 'Печать снята, вещи снова ваши',
    bakeStepCard: 'Карточка NFT обновлена',
    bakeCardWait: 'Карточку допишем следом — операция в игре уже прошла.',
    bakeGetgems: 'На Getgems карточка обновится не сразу: там свой кэш, его можно обновить кнопкой на странице предмета.',
    unbakeOk: 'Разблокировать',
    unbakeTitle: 'Разблокировать комплект?',
    unbakeWarn: 'Печать снимется, вещи снова станут обычной амуницией — их можно будет снять, продать и разобрать. Разблокировка бесплатна.',
    takeOk: 'Забрать в игру',
    takeTitle: 'Забрать комплект в игру?',
    nftBaked: 'Комплект запечён',
    nftEnergyBonus: '+{pct}% энергии за взятую фигуру противника',
    exchangeOpen: 'Обменять',
    exchangeTitle: 'Обмен $ENRG на энергию',
    exchangeRate: 'Курс 1:1, целыми токенами. Токены сжигаются безвозвратно, энергия идёт в баланс.',
    exchangeAmount: 'Сколько токенов',
    exchangeGets: 'Получите энергии: {n}',
    exchangeGas: 'Комиссию сети платит кошелёк — на нём нужно немного GRAM.',
    exchangeToday: 'Сегодня уже обменяно: {n}',
    exchangeOk: 'Обменять',
    exchangeBusy: 'Ждём подпись…',
    exchangeWaiting: 'Операция отправлена. Ждём, когда её увидит блокчейн — обычно 1-2 минуты. Окно можно закрыть: энергия придёт сама, а в профиле останется отметка об ожидании.',
    exchangeDone: 'Готово: зачислено {n} энергии.',
    exchangeDeferred: 'Сжигание принято, но дневной предел обмена на сегодня исчерпан: {n} энергии зачислим, как только предел обновится. Токены не потеряны, делать ничего не нужно.',
    // 🔴 Это НЕ ошибка, а нормальный ход событий: блокчейн подтверждает не мгновенно. Текст обязан
    // успокаивать и говорить, что делать (ничего), иначе игрок решит, что деньги пропали.
    exchangeSlow: 'Блокчейн ещё подтверждает операцию — это нормально. Энергия придёт сама, окно можно закрыть: мы сообщим о зачислении здесь, в профиле.',
    exchangePending: '⏳ Обмен в пути: {n} энергии придёт, как только блокчейн подтвердит операцию (обычно 1-2 минуты).',
    nftNoticeExchange: '✅ Обмен $ENRG завершён: зачислено {n} энергии.',
    exchangeInApp: 'Обмен $ENRG на энергию доступен на сайте игры, вне Telegram.',
    exchangeConnect: 'Подключить кошелёк',
    exchangeWaitWallet: 'Ждём кошелёк…',
    exchangeBridgeOn: 'В браузере подключён кошелёк {addr}.',
    exchangeBridgeOff: 'В браузере кошелёк не подключён — подпись сейчас невозможна.',
    exchangeNeedConnect: 'Чтобы подписать операцию, подключите кошелёк в этом браузере. Привязка к аккаунту уже есть — она не потеряется.',
    walletMismatch: 'В браузере подключён другой кошелёк. Отключите его в окне кошелька и подключите тот, что привязан к аккаунту.',
    walletRaw: 'Кошелёк отказал: {text}',
    nftNoticeGone: 'NFT-воин ({who}) больше не в вашем кошельке — фигура вышла из состава, на её место вернулась ваша.',
    nftNoticeListed: 'NFT-воин ({who}) выставлен на продажу: бонус к энергии снят, амуниция вернулась в сундук.',
    nftNoticeItems: 'Вещей возвращено в сундук: {n}.',
    nftNoticeRentBack: 'Фигура из аренды вернулась к вам: {who}.',
    // сколько всего сообщений в отчёте: строки едут в своей прокрутке, и без счётчика не видно,
    // что под первой есть ещё
    nftNoticeCount: 'сообщений: {n}',
    // подпись крестика (title + aria-label): сам значок ✕ немым не оставляем
    nftNoticeClose: 'Закрыть сообщение',
    nftSomeFigure: 'фигура',
    referralTitle: 'Пригласи друзей — получай билеты 🎟️',
    referralWhy: 'Друг получает 5 билетов колеса за регистрацию по вашей ссылке, вы — по билету за каждую его партию, до 5 за друга.',
    invited: 'Приглашено',
    copy: 'Копировать',
    copied: 'Скопировано',
    gemHint: '{name} — наведите/нажмите для разбивки по размерам',
    gemBySize: '{name} по размерам',
  },
  login: {
    signUp: 'Регистрация',
    login: 'Вход',
    username: 'Логин',
    password: 'Пароль',
    email: 'E-mail',
    submit: 'ОК',
    failed: 'Не удалось войти. Проверьте логин и пароль',
  },
  pvp: {
    start: 'В бой',
    yourPower: 'Ваша сила',
    oppPower: 'Сила соперника',
    deviation: 'Допуск по силе соперника',
    gameMode: 'Режим игры',
    modeKillKingTimer: 'Убить короля за 20 минут',
    allowBot: 'Разрешить подсадку бота',
    allowBotHint: 'Партии с ботом не дают энергию, рейтинг и добычу',
    botSurrender: 'Бот сдаётся в безнадёжной позиции',
    botSurrenderHint: 'Снимите галочку, чтобы добивать бота полностью',
    botDifficulty: 'Сложность бота',
    botEasy: 'Лёгкий',
    botMedium: 'Средний',
    botHard: 'Сложный',
    // Имена ниже остались от прежней восьмиступенчатой шкалы (уровни 3-7): ползунок их больше
    // не показывает, но каталог сообщений и старые сборки на них ссылаются — не удаляем.
    botSkilled: 'Опытный',
    botExpert: 'Эксперт',
    botMaster: 'Мастер',
    botGrand: 'Гроссмейстер',
    botLegend: 'Легенда',
    botEasyHint: 'Играет без тактической карты силы и ошибается. Партия ничего не приносит',
    botMediumHint: 'Видит карту силы, но партию вперёд не считает. С него падают амуниция и ресурсы; рейтинг и победы не засчитываются',
    botHardHint: 'Просчитывает партию вперёд и думает до 30 секунд на ход, умный бой и король. Даёт амуницию, ресурсы и энергию в баланс за фигуры; рейтинг и победы не засчитываются',
    botBrainHint: 'Просчитывает партию на {n} ходов вперёд и думает до 5 секунд на ход. Награды — как у Сложного; рейтинг и победы не засчитываются',
    vs: 'против',
    activeMatches: 'Активные партии',
    watchActive: 'Смотреть активные партии',
    noActive: 'Сейчас нет активных партий',
    returnToMatch: 'Вернуться в партию',
    surrender: 'Сдаться',
    surrenderConfirm: 'Сдаться в текущей партии? Будет засчитано поражение.',
    figures: 'Настройки фигур',
    tourNotStarted: 'Турнир ещё не начался',
    fightInProgress: 'Идёт поединок',
    viewers: 'Зрителей',
    likes: 'Лайков',
  },
  leaderboard: {
    name: 'Игрок',
    power: 'Сила',
    win: 'Победы',
    lose: 'Поражения',
    energy: 'Энергия',
    rating: 'Рейтинг',
    viewFigures: 'Посмотреть настройки фигур игрока',
  },
  wheel: {
    ammoWon: '{rarity} предмет (ур. {level}) — в сундук',
    // Редкая и выше добыча приходит СУНДУКОМ с таймером (решение оунера 2026-08-29)
    boxWon: '{rarity} сундук — откроется через {time}',
    boxesWon: 'сундуков: {n} — они ждут в вашем сундуке',
    sector_energy: 'Энергия',
    sector_material: 'Материалы',
    sector_gem: 'Самоцветы',
    sector_ammo_common: 'Обычная',
    sector_ammo_rare: 'Редкая',
    sector_ammo_super_rare: 'Супер редкая',
    sector_ammo_unique: 'Уникальная',
    sector_ammo_epic: 'Эпическая',
    title: 'Колесо Фортуны',
    tickets: 'Билеты: {n}',
    spin1: 'Крутить ×1',
    spinN: 'Крутить ×{n}',
    spinning: 'Крутим…',
    noTickets: 'Нет билетов',
    fewTickets: 'Мало билетов',
    boost: 'В колесе повышенный шанс редкой добычи: уникальная амуниция выпадает в 3 раза чаще, а эпическая — в 10 раз чаще, чем во время партии.',
    buyTickets: 'Купить билеты',
    buy: 'Купить',
    ticketPrice: '1 билет = {energy} ⚡ + {gems} самоцвет(ов) + {materials} материал(ов) (случайные)',
    total: 'Итого: {energy} ⚡ + {gems} самоцвет(ов) + {materials} материал(ов)',
    dailyLimit: 'Не более {n} билетов в день',
    canBuyNow: 'Доступно к покупке: {n}',
    cannotBuy: 'Сейчас купить нечего: нет ресурсов или исчерпан дневной лимит',
    dailyDone: 'Дневной лимит покупки исчерпан — новые билеты можно купить завтра',
    resultOne: 'Итог вращения',
    resultMany: 'Итог {n} вращений',
    nothing: 'В этот раз ничего.',
    rewardTaken: 'Награда получена.',
    rewardBlocked: 'Награда недоступна (аккаунт под ограничением).',
    itemLost: 'Предмет выпал, но хранилище переполнено — потерян.',
    lost: 'Потеряно (хранилище полно): {n}',
    toChest: 'В сундук',
    take: 'Забрать',
    noAmmo: 'Амуниция не выпала',
    noRes: 'Ресурсы не выпали',
    energyLine: '⚡ Энергия:',
    gemsLine: '💎 Малые самоцветы:',
    matsLine: '🪵 Материалы:',
    energyToBalance: 'Энергия (в баланс)',
    notEnoughEnergy: 'Недостаточно энергии',
    notEnoughGems: 'Недостаточно самоцветов',
    notEnoughMats: 'Недостаточно материалов',
    buyFailed: 'Не удалось купить билеты',
  },
  kind: {
    helmet: 'Шлем', pauldrons: 'Наплечники', bracers: 'Наручи', cuirass: 'Доспех', pants: 'Штаны',
    belt: 'Пояс', boots: 'Сапоги', gloves: 'Перчатки', shield: 'Щит', quiver: 'Колчан',
    amulet: 'Амулет', ring: 'Кольцо', sword: 'Меч', bow: 'Лук', staff: 'Посох', axe: 'Топор',
    knife: 'Нож', flask: 'Бутылёк', bridle: 'Уздечка', spellbook: 'Книга',
    wall_talisman: 'Талисман стены', cloak: 'Плащ', mind_cast: 'Слепок сознания',
    ammo: 'амуниция', level: 'ур',
  },
  tour: {
    errLoad: 'Не удалось загрузить турниры',
    flowReg: 'Набор',
    flowActive: 'Идёт',
    flowResults: 'Итоги',
    flowTransfer: 'Перенос наград',
    title: 'Турниры',
    subtitle: 'Отдельный профиль · равный старт · ценные награды',
    footer: 'Один турнир за раз · турнирный профиль отдельный: фигуры и амуниция основного аккаунта не переносятся',
    ticketsPill: '🎟 Билетов: {n}',
    tabActive: 'Актуальные',
    tabMine: 'Мои',
    tabHall: 'Зал славы',
    stateRegistration: 'Набор',
    stateActive: 'Идёт',
    stateFinished: 'Завершён',
    stateArchived: 'Архив',
    btnJoin: 'Участвовать',
    btnEnter: 'Продолжить турнир',
    btnBoard: 'Таблица',
    btnDetails: 'Подробнее',
    btnClaim: 'Забрать награду',
    btnFull: 'Мест нет',
    youParticipate: 'вы участвуете',
    nearest: 'ближайший турнир',
    placeOf: 'место из {n}',
    rating: 'рейтинг',
    wins: 'победы',
    toPrizes: 'мест до призов',
    inPrizes: 'вы в призах',
    start: 'старт',
    finish: 'финиш',
    participants: 'участников',
    participantsN: '{n} участников',
    seatsOf: '{n} из {max}',
    prize: 'приз',
    entry: 'вход',
    entryFree: 'бесплатно',
    claimUntil: 'забрать до',
    claimIn: 'забрать за',
    untilStart: 'до старта',
    untilEnd: 'до конца',
    untilRegEnd: 'до конца записи',
    youTook: 'вы заняли {n} место',
    allTournaments: '← Все турниры',
    backToCard: 'К карточке турнира',
    myFigures: 'Мои фигуры',
    boardTitle: 'Турнирная таблица',
    boardOf: 'Таблица · {title}',
    boardSub: '{n} участников · обновляется после каждой партии',
    boardNote: 'Место считается по турнирному рейтингу: заработанная энергия, взвешенная долей побед',
    boardEmpty: 'Участников пока нет.',
    boardLoading: 'Загрузка таблицы…',
    boardAll: 'вся таблица',
    boardGap: 'До {n} места не хватает {gap} рейтинга',
    rewardsTitle: 'Награды призёрам',
    rewardsEmpty: 'Награды объявим позже.',
    rewardsNote: 'Награды приходят на турнирный профиль. Забрать на основной аккаунт можно до {date}.',
    myInterval: 'ваш интервал',
    rulesOwn: '📜 Правила турнира',
    rulesCommon: '📖 Общие правила турниров',
    rulesJoin: '🧭 Как устроено участие',
    joinTitle: 'Вступить в турнир «{title}»?',
    joinFree: 'Участие бесплатно',
    joinPrice: 'Участие: {n} 🎟',
    joinOnce: 'Один турнир за раз',
    joinConfirm: 'Вступить в турнир',
    joinFull: 'Все места заняты',
    joinBusy: 'Вы уже в турнире',
    claimTitle: 'Награда за турнир',
    claimInterval: 'интервал наград {label}',
    claimWhere: 'Всё это перейдёт на основной аккаунт: амуниция — в сундук, ресурсы и энергия — на баланс.',
    claimDeadline: 'Забрать можно до {date}. После этого турнирный профиль и его содержимое удаляются.',
    claimBtn: 'Забрать на основной аккаунт',
    claimDone: 'Награда зачислена на основной аккаунт',
    claimNothing: 'Переносить нечего.',
    claimNoPrize: 'За ваше место наград не предусмотрено, но всё нажитое в турнире можно перенести.',
    itemsCount: 'предметов',
    energyCount: 'энергии',
    hallTitle: 'Ваши трофеи',
    hallSubtitle: 'за всё время',
    hallPlayed: 'турниров сыграно',
    hallWins: 'побед',
    hallPrizes: 'раз в призах',
    hallNotPlayed: 'Вы не участвовали',
    hallPlayed1: 'Вы участвовали',
    hallEmpty: 'Завершённых турниров пока нет.',
    hallNote: 'Нажмите на турнир, чтобы посмотреть его полную таблицу и список наград',
    emptyTitle: 'Сейчас турниров нет',
    emptyText: 'Ближайший турнир объявим здесь — набор обычно открывается за несколько дней до старта.',
    backToProfile: 'Вернуться в профиль',
    inSeason: 'Вы в турнире',
    inSeasonHint: 'вы играете в турнирном профиле',
    menuBtn: 'Меню турнира',
    exit: 'Выйти в основной профиль',
    errJoin: 'Не удалось зарегистрироваться',
    errEnter: 'Не удалось войти',
    errTransfer: 'Не удалось перенести',
    deskTitle: 'Турнирный профиль',
    deskSubtitle: 'всё внутри турнира отдельное от основного аккаунта',
    deskProgress: 'Ваш прогресс в турнире',
    deskNote: 'Основной аккаунт на паузе, пока вы в турнире: рейтинг, фигуры и амуниция там не меняются',
    deskWaiting: 'ожидаем старта турнира',
    deskNotStarted: 'Турнир ещё не начался',
    deskOpensOnStart: 'откроется на старте турнира',
    tilePlay: 'В бой|соперники — только участники турнира',
    tilePack: 'Мои фигуры|амуниция и настройки турнирной армии',
    tileBoard: 'Таблица|ваше место и лидеры турнира',
    tileMarket: 'Рынок турнира|торговля только внутри турнира',
    tileWheel: 'Колесо фортуны|билеты и случайные призы',
    tileRewards: 'Награды|что дают за ваше место',
    tileRules: 'Правила|сроки, призы, условия переноса',
    collapse: 'Свернуть',
    rulesOwnPlain: 'Правила этого турнира',
    rulesCommonPlain: 'Общие правила турниров',
    rulesJoinPlain: 'Как устроено участие',
    played: 'сыграно {n} партий',
    inPrizeZone: 'вы в призовой зоне',
    toPrizesN: 'до призов {n} мест',
    placeShort: 'место',
  },
  // МАГАЗИН ЗА TELEGRAM STARS (`BackEnd/docs/STARS_SHOP_PLAN.md`). 🔴 Названия и описания товаров
  // приходят С СЕРВЕРА (правятся в админке) и не переводятся — переведён СОСТАВ набора и вся
  // обвязка: именно по составу игрок понимает, за что платит.
  stars: {
    title: 'Магазин',
    subtitle: 'Наборы за звёзды Telegram',
    buy: 'Купить',
    buying: 'Открываем счёт…',
    guaranteed: 'Гарантирован: {rarity} предмет {level} уровня',
    guaranteedKind: 'Гарантирован: {kind} ({rarity}), {level} уровня',
    oddsTitle: 'Шансы по типам предметов',
    kitsTitle: 'Наборы',
    kitsNote: 'фиксированный состав — что видите, то и получите',
    boxesTitle: 'Сундуки',
    boxesNote: 'редкость и уровень гарантированы, вид предмета — случайный',
    badge: {
      starter: 'Для начала',
      hit: 'Хит',
      value: 'Выгодно',
      best: 'Лучшее',
    },
    oddsHint: 'Редкость и уровень гарантированы, случаен только тип. Проценты берутся из тех же таблиц, по которым игра выдаёт предмет.',
    limit: 'сегодня куплено {n} из {of}',
    limitWeek: 'за неделю куплено {n} из {of}',
    limitMonth: 'за 30 дней куплено {n} из {of}',
    refresh: 'Обновить',
    closed: 'Магазин пока закрыт.',
    empty: 'Наборов сейчас нет.',
    noLink: 'Не удалось открыть счёт — попробуйте ещё раз.',
    payFailed: 'Оплата не прошла. Звёзды не списаны.',
    paid: 'Оплата принята',
    waiting: 'Выдаём набор — это занимает несколько секунд.',
    granted: 'Набор выдан ✓',
    grantedHint: 'Расходники уже в кошельке, предметы — в сундуке или в почте наград.',
    grantedMany: 'Выдано покупок: {n} — вместе с этой пришли оплаты, которые не дошли раньше.',
    failedGrant: 'Оплата прошла, но товар не выдан',
    failedGrantHint: 'Такого товара нет в магазине — возможно, его убрали с витрины. Напишите /paysupport, звёзды вернём.',
    // Окно «что получил» после покупки (просьба оунера 2026-08-28)
    gotTitle: 'Покупка выдана',
    gotNote: 'Расходники уже на счёте, сундук ждёт в общем сундуке.',
    gotBox: 'Сундук лёг в ваш сундук',
    gotBoxNote: 'Откроется через {time}. Ждать можно бесплатно или ускорить песками времени.',
    gotBoxSoon: 'меньше минуты',
    gotToChest: 'Перейти в сундук',
    gotOk: 'Понятно',
    slow: 'Оплата прошла, набор ещё не доехал',
    slowHint: 'Telegram иногда сообщает об оплате с задержкой. Набор придёт сам — загляните позже, ничего делать не нужно.',
    inAppOnly: 'Покупка — в приложении Telegram',
    inAppHint: 'Звёздами платят внутри Telegram: в обычном браузере окна оплаты просто нет. Откройте игру в мини-приложении — каталог и цены там те же.',
    inAppShort: 'только в Telegram',
    openApp: 'Открыть в Telegram',
  },
  market: {
    consumables: 'Расходники',
    title: 'Рынок',
    tabBuy: 'Купить',
    tabMine: 'Мои лоты',
    tabSell: 'Выставить',
    resShortMat: 'мат.',
    resShortGem: 'сам.',
    tabRes: 'Ресурсы',
    tabRent: 'Аренда NFT',
    resShopNote: 'Материалы и малые самоцветы за энергию. Крупные самоцветы здесь не продаются — только добыча.',
    resShopOff: 'Раздел «Ресурсы» сейчас закрыт.',
    tabShop: 'Инструменты',
    shopNote: 'Лавка мастеров: расходники за ресурсы. Цена фиксированная, продавец — сама лавка.',
    canBuyNow: 'Доступно к покупке: {n}',
    shopBought: 'Покупка совершена',
    goodsMinutes: '+{n} мин к восстановлению',
    goodsPieces: '{n} шт.',
    goodsDesc: {
      boost_minutes: 'Ускоряют лечение и оживление фигур: снимают минуты с таймера восстановления.',
      scroll_apprentice: 'Автоподбор лучшей амуниции для ОДНОЙ фигуры из сундука и её инвентаря.',
      scroll_master: 'Автоподбор по всей фракции в заданном порядке: сильные выбирают первыми.',
      hammer: 'Разбор с материалами и самоцветами: один молот — на одну вещь в мульти-разборе.',
      ether: 'Перезарядка классового предмета: один эфир — один заряд любой редкости.',
    },
    goods: {
      boost_minutes: 'Пески времени',
      scroll_apprentice: 'Свиток подмастерья',
      scroll_master: 'Свиток мастера',
      hammer: 'Молот кузнеца',
      ether: 'Эфир',
    },
    balance: 'Баланс:',
    type: 'Тип:',
    category: 'Категория:',
    kind: 'Вид:',
    subkind: 'Подвид:',
    rarity: 'Редкость:',
    sort: 'Сортировка:',
    material: 'Материал:',
    size: 'Размер:',
    price: 'Цена:',
    all: 'Все',
    anyF: 'Любая',
    anyM: 'Любой',
    ammo: 'Амуниция',
    resources: 'Ресурсы',
    materials: 'Материалы',
    gems: 'Самоцветы',
    armor: 'Броня',
    weapon: 'Оружие',
    jewelry: 'Украшения',
    classItems: 'Классовые',
    sortNew: 'Новые',
    sortCheap: 'Дешевле',
    sortExpensive: 'Дороже',
    sortPowerUp: 'Сила ↑',
    sortPowerDown: 'Сила ↓',
    emptyLots: 'Нет лотов по выбранным фильтрам.',
    emptyRes: 'Нет ресурсов по выбранным фильтрам.',
    emptyAmmo: 'Нет амуниции по выбранным фильтрам.',
    emptyFilters: 'По фильтрам ничего не найдено.',
    buy: 'Купить',
    buyLot: 'Купить лот',
    sell: 'Выставить',
    sellLot: 'Выставить на продажу',
    remove: 'Снять',
    itemUnavailable: 'Предмет недоступен',
    notEnoughEnergy: 'Недостаточно энергии',
    notEnoughRes: 'Недостаточно ресурсов для покупки',
    priceLabel: 'Цена в энергии — мин. {min}',
    priceLabelLot: 'Цена в энергии (за весь лот) — мин. {min}',
    fee: 'Комиссия Рынка {pct}% — вы получите',
    resFee: 'Комиссия с ресурсов: {mats} материала и {gems} самоцвет из указанных сгорают.',
    investedLabel: 'Вложено в улучшение:',
    unlockedLabel: 'Разделы улучшения:',
    socketsBusy: 'занято {n}',
    socketsNone: 'Гнёзда ещё не пробиты',
    unlockedYes: 'Раздел уже оплачен прежним владельцем',
    unlockedNo: 'Раздел закрыт — открывать придётся самому',
    commentLabel: 'Комментарий к лоту (необязательно)',
    commentHint: 'Например: заточена под мага, два свободных гнезда',
    extraRes: 'Доплата ресурсами (необязательно)',
    addRes: '+ добавить ресурс к цене',
    plusRes: '+ ресурсы:',
    pickRes: '— ресурс —',
    have: 'есть: {n}',
    qty: 'Количество (есть {n})',
    okList: 'Лот выставлен на Рынок.',
    okCancel: 'Лот снят с продажи.',
    okBuy: 'Покупка совершена — предмет в сундуке.',
    errList: 'Не удалось выставить.',
    errCancel: 'Не удалось снять лот.',
    errBuy: 'Не удалось купить.',
    rarityShort_common: 'Обычн.',
    rarityShort_rare: 'Редк.',
    rarityShort_super_rare: 'Супер',
    rarityShort_unique: 'Уник.',
    rarityShort_epic: 'Эпич.',
  },
  skill: {
    precise_strike: 'Точный удар',
    draining_shot: 'Осушающий Выстрел',
    acid_orb: 'Кислотный  Шар',
    cleaver: 'Рассекатель',
    knee_breaker: 'Дробитель Колен',
    leech: 'Пиявка',
    zombie_rage: 'Ярость Зомби',
    mage_slayer: 'Убийца Магов',
    assassin_arrow: 'Стрела Ассасина',
    adrenaline: 'Адреналин',
    mage_ward: 'Защита от Магов',
    arcane_armor: 'Магический Доспех',
    ram: 'Таран',
    blessing: 'Благославление',
    guarding_heal: 'Защитное Исцеление',
    unbreakable_armor: 'Нерушимый Доспех',
    cursed_arrow: 'Проклятая Стрела',
    forest_curse: 'Проклятье Леса',
  },
  rent: {
    title: 'Аренда NFT-воинов',
    badInput: 'Проверьте введённые значения: срок и цена — целые числа.',
    balance: 'Баланс:',
    tabMarket: 'Витрина',
    tabOut: 'Я сдал',
    tabIn: 'Я взял',
    marketHint: 'Фигура приезжает вместе с запечённым комплектом. Комиссия рынка — {pct}%.',
    marketEmpty: 'Сейчас никто не сдаёт фигуры в аренду.',
    outHint: 'Отсюда видно, сколько принесла каждая сданная фигура и во сколько обойдётся её досрочный возврат.',
    outEmpty: 'Вы пока ничего не сдавали.',
    inHint: 'Арендованной фигурой можно играть, но менять её амуницию нельзя — она принадлежит владельцу.',
    inEmpty: 'Вы пока ничего не арендовали.',
    owner: 'Владелец',
    renter: 'Арендатор',
    mine: 'Это ваша фигура',
    level: 'Уровень {n}',
    energyBonus: '+{pct}% энергии за взятие',
    perDay: '{n} ⚡ за сутки',
    percentOf: '{pct}% от заработка фигуры',
    maxDays: 'Не дольше {n} сут.',
    daysLeft: 'На витрине ещё {n} сут. — на столько и можно взять',
    offerWindow: 'На витрине ещё {n} сут.',
    relisted: 'Фигура вернулась и снова ждёт арендатора.',
    days: 'Суток:',
    deposit: 'Спишется сразу: {n} ⚡',
    noDeposit: 'Депозит не нужен: доля идёт с заработка фигуры.',
    take: 'Взять в аренду',
    takeDone: 'Фигура у вас — поставьте её в состав в «Настройках фигур».',
    notEnough: 'Не хватает {n} ⚡',
    daysWhy: 'Укажите срок от 1 до {n} суток',
    careCost: 'Лечение {heal} ⚡ · оживление {revive} ⚡ — платит арендатор',
    waitingRenter: 'Ждёт арендатора',
    dayOf: 'Сутки {n} из {total}',
    gotTotal: 'Получено всего: {n} ⚡',
    depositLeft: 'Ещё заморожено: {n} ⚡',
    earned: 'Фигура заработала: {n} ⚡',
    paidToday: 'Принесла с начала суток: {n} ⚡',
    recallPrice: 'Досрочный возврат стоит {n} ⚡',
    recall: 'Вернуть фигуру',
    recallAsk: 'Арендатору вернётся {back} ⚡, из них {n} ⚡ спишется с вашего баланса. Плата за прошедшие сутки остаётся у вас.',
    recallNoMoney: 'Нужно вернуть {n} ⚡, у вас {have} ⚡',
    recallPending: 'Отозвана — вернётся, как только арендатор доиграет партию.',
    recalledByOwner: 'Владелец отозвал фигуру — она вернётся после партии.',
    cancelOffer: 'Снять с витрины',
    cancelAsk: 'Снять предложение? Фигура останется у вас.',
    offerTitle: 'Сдать свою фигуру',
    noRentable: 'Сдавать нечего: нужна NFT-фигура вне состава, целая и с запечённым комплектом.',
    maxDaysField: 'Срок на витрине, сут.:',
    maxDaysHint: 'Столько суток фигура стоит на витрине. Внутри этого срока она возвращается в ожидание нового арендатора после каждого возврата, по его концу — снимается сама.',
    kindFix: 'Плата за сутки',
    kindPct: '% от заработка',
    priceField: 'Цена, ⚡/сут.:',
    percentField: 'Доля, %:',
    feeNote: 'С каждой выплаты удерживается комиссия рынка {pct}%.',
    offer: 'Выставить',
    offerDone: 'Фигура выставлена в аренду.',
    paidByMe: 'Внесено: {n} ⚡',
    sharePaid: 'Отдано владельцу: {n} ⚡',
    giveBack: 'Вернуть владельцу',
    giveBackAsk: 'Вернуть фигуру владельцу? Доля берётся только с заработка, поэтому терять нечего.',
    noEarlyReturn: 'Досрочно вернуть нельзя — срок был выбран вами.',
  },
  stat: {
    physical_damage: 'Физ. урон', magic_damage: 'Маг. урон',
    physical_resist: 'Физ. защита', magic_resist: 'Маг. защита',
    speed: 'Инициатива', dodge: 'Уклонение',
    health: 'Здоровье', max_health: 'Макс. HP', health_regeneration: 'Реген HP',
    mana: 'Мана', max_mana: 'Макс. маны', mana_regeneration: 'Реген маны',
    stamina: 'Выносл.', max_stamina: 'Макс. выносл.', stamina_regeneration: 'Реген выносл.',
    power: 'Сила',
  },
  unit: {
    Pawn: 'Пешка', Knight: 'Рыцарь', Bishop: 'Епископ', Rook: 'Ладья', Queen: 'Королева', King: 'Король',
    Warrior: 'Воин', Mage: 'Маг', Archer: 'Лучник',
    Elf: 'Эльфы', Zombie: 'Зомби', ElfGen: 'Эльфов', ZombieGen: 'Зомби',
  },
  ability: {
    charges: 'Заряды: {left}/{max}',
    recharge: 'Перезарядка: {n} р.',
    regenHp: '{n} к реген. HP {suffix}',
    regenMana: '{n} к реген. маны {suffix}',
    regenStamina: '{n} к реген. выносл. {suffix}',
    bridleNote: 'Доп. ход в конце раунда (раз за поединок)',
    bridleDmg: 'Урон доп. атаки: {pct}%',
    wallNoteRank: 'Ставит Стену, блокирующую подкласс «{rank}»',
    wallNote: 'Ставит Стену, блокирующую вражеский подкласс',
    wallStats: 'Стена: {hp} HP, {pct}% защиты',
    cloakNote: 'Невидимость для врагов (атакует с 50% урона)',
    boardLightningText: '{n} урона врагу (не добивает: остаётся 1 HP)',
    boardWallNote: 'Ставит стену на пустую клетку: её нельзя пройти и нельзя атаковать. И усиливает саму Ладью',
    boardWallRadius: 'Клетка для стены — пустая, в радиусе {n} клетки от Ладьи',
    boardBridleNote: 'Даёт дополнительный ход: можно сходить дважды подряд',
    boardCloakNote: 'Ферзь ходит, но не атакует; атаковать его тоже нельзя, а клетку он перекрывает',
    boardSpellRadius: 'Цель — фигура в радиусе {n} клетки (можно и себя)',
    boardSoilNote: 'Зона на любой клетке доски. Фигура, которая на ней стоит, каждый свой ход получает прибавку к ресурсам: своя со знаком «+», вражеская со знаком «−»',
    boardSoilFight: 'Начнётся поединок на этой клетке — зона действует на всех его участников',
    boardSoilAlly: 'Своей фигуре на клетке',
    boardSoilEnemy: 'Вражеской фигуре на клетке',
    soilNote: 'Зона на клетке: союзникам +Восстановления, врагам −. Если на этой клетке идёт поединок, зона действует на ВСЕХ его участников',
    spellHealText: '+{n} HP союзнику',
    spellLightningText: '{n} урона врагу',
    spellStrengthText: '+{n} к реген. маны/выносл. союзнику',
    spellWeaknessText: '−{n} к реген. маны/выносл. врагу',
    // 🔴 У КАЖДОГО РЕСУРСА СВОЁ ЧИСЛО (правка оунера 2026-09-12): книга двигает реген маны своим
    // статом, а выносливость — своим, поэтому одно число на оба ресурса врало бы игроку.
    spellStrengthPair: '+{m} к реген. маны, +{s} к реген. выносл. союзнику',
    spellWeaknessPair: '−{m} к реген. маны, −{s} к реген. выносл. врагу',
    flaskRow: 'Мгновенно +{n} здоровья себе',
    flaskRegenRow: '+{n} к реген. здоровья на {d} р.',
    bridleSpeedRow: '+{n} к инициативе на {d} р.',
    bridleDodgeRow: '+{n}% к уклонению на {d} р.',
    wallRow: 'Стена на своей клетке: {hp} HP, {pct}% защиты',
    wallBlockRank: 'Блокирует подкласс: {rank}',
    wallBlock: 'Блокирует вражеский подкласс',
    wallBuffHp: 'Ладье +{n} к макс. HP, пока Стена стоит',
    wallBuffRegen: 'Ладье +{n} к реген. HP, пока Стена стоит',
    wallDuration: 'Стена держится {d} р.',
    cloakRow: 'Невидимость для врагов на {d} р. (атакует с 50% урона)',
    cloakSuffix: '+себе',
    soilRow: 'Клетка на {d} р.: союзнику +Восстановления, врагу −',
    soilSuffix: '±на клетке',
    spellHealRow: '+{n} здоровья союзнику',
    spellLightningRow: '{n} урона врагу',
    spellStrengthRow: '+{m} к реген. маны, +{s} к реген. выносл. союзнику на {d} р.',
    spellWeaknessRow: '−{m} к реген. маны, −{s} к реген. выносл. врагу на {d} р.',
    flask: 'Бутылёк',
    bridle: 'Ускорение',
    spellbook: 'Заклинания',
    wall: 'Стена',
    cloak: 'Плащ',
    soil: 'Почва',
    pawnDesc: 'Пешка: мгновенно восстанавливает здоровье и даёт бафф регена HP на несколько раундов (на себя).',
    knightDesc: 'Рыцарь: бафф инициативы и один дополнительный ход в конце раунда (раз за поединок).',
    bishopDesc: 'Епископ: одно из четырёх — Лечение, Молния, Сила, Слабость (по цели/союзнику).',
    rookDesc: 'Ладья: ставит препятствие на своей половине поля, блокирует вражеский подкласс; пока стоит — бафф Ладье.',
    queenDesc: 'Королева: невидимость для врагов + все Восстановления; атакует из-под плаща вполсилы.',
    kingDesc: 'Король: зона на клетке — союзникам +Восстановления, врагам −; действует и на доске, и в бою.',
  },
  pack: {
    rentedOut: 'Сдано в аренду фигур: {n} — они вернутся по концу срока.',
    rentedOutLink: 'Посмотреть аренды',
    nftOn: 'На этой фигуре стоит NFT-воин',
    nftStanding: 'Играет NFT-воин',
    // Запечённый комплект: замок на вещах говорит «нельзя», а эти строки — почему и что делать.
    rentedUnit: 'Фигура взята в аренду: её амуницию меняет только собственник. Заряды классового предмета вы можете восстановить сами.',
    itemBaked: 'Предмет запечён на NFT-воине: снять, переложить, продать и разобрать его нельзя. Разблокировать — в профиле, на карточке фигуры.',
    bakedOnUnit: '🔒 Комплект запечён на NFT ({n} предм.) — разблокировать можно в профиле',
    nftListed: '⚠️ NFT выставлена на продажу: бонус к энергии снят, амуниция вернулась в сундук',
    nftGone: '⚠️ NFT больше не в вашем кошельке — поставьте на её место свою фигуру',
    nftRemove: 'Снять NFT',
    nftReplace: 'Заменить на NFT-воина',
    nftPickTitle: 'Кого поставить вместо: {name}',
    nftNoneFit: 'Подходящих NFT нет: нужна фигура той же фракции и того же класса.',
    nftBusy: 'Эта NFT уже стоит в вашем составе',
    nftBusyShort: 'занята',
    nftLevel: 'ур. {n}',
    nftHint: 'Заменить можно фигуру той же фракции и класса. NFT-воин — ОТДЕЛЬНАЯ фигура со своей амуницией: заменённая уходит в запас целиком, со всеми своими вещами, и вернётся такой же.',
    nftAttached: 'NFT-воин встал в строй.',
    nftKeepsGear: 'Амуниция не переносится: у NFT-воина своя',
    nftHasGear: 'своя амуниция: {n}',
    bench: 'В запасе',
    benchToSquadHint: 'Перетащите фигуру из запаса на фигуру того же класса в составе.',
    squadSwapped: 'Состав изменён: «{name}» ушла в запас со своей амуницией.',
    benchNote: 'Фигура в запасе: в партию не идёт и в автоподбор не входит, но её вещи доступны',
    benchMoved: 'Фигура «{name}» ушла в запас со всей своей амуницией.',
    nftRemoved: 'NFT-воин ушёл в запас, стоковая фигура вернулась в строй.',
    rechargeEther: 'Эфиром ({n})',
    rechargeEtherHint: 'Восстановить заряды эфиром: 1 эфир = 1 заряд',
    tipAutofillUnit: 'Автоподбор лучшей амуниции на фигуру (свитков подмастерья: {n})',
    tipAutofillFraction: 'Автоподбор лучшей амуниции на всю фракцию (свитков мастера: {n})',
    autofillDone: 'Автоподбор: изменено предметов — {n}',
    autofillNothing: 'Улучшить нечем — свиток не потрачен',
    autofillSkipped: 'Пропущено раненых фигур: {n} — сначала вылечите их',
    orderWounded: 'Раненую фигуру одеть нельзя — сначала вылечите её',
    boostTitle: 'Минуты ускорения (у вас: {have})',
    boostApply: 'Ускорить',
    orderTitle: 'Очередь автоподбора',
    orderNote: 'Кликайте по фигурам — свиток оденет их в этом порядке (кто раньше, тот забирает лучшее).',
    orderPicked: 'Выбрано фигур: {n} — остальные не трогаем',
    orderAll: 'Ничего не выбрано — оденем всю фракцию в порядке по умолчанию',
    orderApply: 'Применить свиток',
    orderReset: 'Сбросить выбор',
    mainStatTitle: 'Главный стат подбора',
    mainStatHint: 'Свиток соберёт комплект вокруг «{stat}» — остальные статы идут следом в обычном порядке.',
    mainStat: {
      health: 'Жизни',
      dodge: 'Уклонение',
      speed: 'Инициатива',
      resist: 'Защита',
      health_regeneration: 'Реген жизней',
      resource_regeneration: 'Реген маны/выносл.',
      resource: 'Мана/выносливость',
      damage: 'Урон',
    },
    boostBuyAt: 'Пески времени продаются в магазине на Рынке',
    // СУНДУКИ С ТАЙМЕРОМ (решение оунера 2026-08-28): контейнер лежит в общем сундуке и тикает
    // 🔴 ИМЯ СУНДУКА — РЕДКОСТЬ + СЛОВО «СУНДУК» (решение оунера 2026-08-31). Прежние имена по
    // источнику («Сундук из магазина») ничего не говорили о содержимом и врали про добычу с боя.
    boxNameRarity: '{rarity} сундук',
    boxNamePlain: 'Сундук',
    boxNameDay: 'Сундук {day}',
    boxNameExtra: '{name} (доп.)',
    boxNameWeek: 'Сундук недели',
    boxNameMonth: 'Сундук вехи месяца',
    boxPromise: 'Внутри: предмет {level} уровня',
    boxReady: 'готов',
    boxReadyNote: 'Сундук готов — можно открывать',
    boxOpensIn: 'Откроется через {time}',
    boxOpen: 'Открыть',
    boxBoost: 'Открыть сейчас за {n} песка',
    boxNoSands: 'Не хватает песков времени — можно просто дождаться таймера',
    boxLootTitle: 'Из сундука выпало',
    boxLootOk: 'Отлично',
    boostDone: 'Восстановление ускорено',
    itemDesc: 'Описание предмета',
    pieceInfo: 'Информация о фигуре',
    inventory: 'Инвентарь',
    storage: 'Хранилище амуниции',
    levelTooLow: 'Амуниция уровня {level} — фигуре нужен уровень не ниже {need}',
    title: 'Настройки фигур',
    desk: '← Рабочий стол турнира',
    findOpponent: 'Найти соперника',
    waitingStart: 'Ожидаем старта турнира…',
    tourNotStarted: 'Турнир ещё не начался',
    surrender: 'Сдаться',
    returnToMatch: 'Вернуться в партию',
    surrenderConfirm: 'Сдаться в текущей партии?',
    chooseUnit: 'Выберите фигуру',
    hoverItem: 'Наведите/кликните на предмет',
    stats: 'Характеристики:',
    noBonuses: 'нет бонусов',
    minLevel: 'Мин. ур.: {n}',
    opensAbility: 'Открывает способность:',
    activeSkills: 'Активные навыки',
    abilityCharges: 'Заряды способности',
    classAbility: 'Классовая способность',
    equip: 'Надеть',
    unequip: 'Снять',
    sell: 'Продать',
    disasm: 'Разобрать',
    // 🔴 МОЛОТ — ОТДЕЛЬНАЯ КНОПКА, И ЭМОДЗИ ЖИВЁТ ТОЛЬКО НА НЕЙ (просьба оунера 2026-09-05:
    // «на кнопке Разобрать эмодзи молотка создаёт впечатление, что это разбор молотом кузнеца»).
    disasmHammer: '🔨 Разобрать молотом ({n})',
    disasmHammerNone: '🔨 Разобрать молотом (нет молота)',
    // ЗАТОЧКА АМУНИЦИИ (docs/SHARPENING_PLAN.md). Цена и шанс приходят С СЕРВЕРА и печатаются как
    // есть — своей копии формул у экрана нет намеренно, она разошлась бы с конфигом молча.
    sharpen: '⚒️ Улучшить',
    sharpenTitle: 'Заточка предмета',
    sharpenNote: 'Заточка поднимает ОДНУ характеристику на шаг. Не вышло — реагенты сгорели, предмет цел.',
    // 🔴 Разделы открываются за плату (решение оунера 2026-09-05): инструмент для заточки и камень
    // трансформации платятся ОДИН раз за предмет, дальше попытки стоят только ресурсы и свитки.
    unlockSharpen: 'Заточка этого предмета ещё не открыта',
    unlockReplace: 'Трансформация этого предмета ещё не открыта',
    unlockNote: 'Доступ покупается один раз. Дальше попытки стоят только ресурсы и свитки.',
    unlockGo: 'Открыть раздел',
    sharpenHaveShort: 'У вас:',
    sharpenStep: 'шаг {n} из {max}',
    sharpenChance: 'шанс {p}%',
    sharpenPity: '+{p}% за неудачи ({n})',
    sharpenGo: 'Заточить',
    sharpenMaxed: 'Характеристика заточена до предела',
    sharpenCapped: 'Характеристика упёрлась в потолок предмета — прироста не будет',
    sharpenCappedAt: 'Характеристика упёрлась в потолок предмета ({cap}%) — прироста не будет',
    sharpenMissing: 'Не хватает: {list}',
    // Массовое выделение в сундуке: разбор пачкой и пачка сундуков (просьба оунера 2026-09-01)
    pickItems: 'Выбрано предметов: {n}',
    pickBoxes: 'Выбрано сундуков: {n} (готовы: {ready})',
    pickAll: 'Выбрать всё',
    pickCancel: 'Снять',
    disasmFree2: 'Разобрать ({n})',
    disasmWithHammer: 'Молотом ({n})',
    boxPickStart: 'Выделить сундуки: открыть или ускорить пачкой',
    boxPickCancel: 'Выйти из выделения сундуков',
    boxOpenAll: 'Открыть ({n})',
    boxBoostAll: 'Ускорить всё ({n} мин)',
    boxBatchMax: 'За раз не больше {n} сундуков',
    boxBoostedAll: 'Ускорено, потрачено песка: {n} мин',
    boxBoostedPartly: 'Песка хватило не на всё: потрачено {n} мин',
    boxBoostPartly: 'Песка у вас {have} мин из нужных {need} — ускорим то, на что хватит',
    sharpenIfAll: 'если все {n} удадутся',
    sharpenMax: 'макс.',
    sharpenPlanned: 'Запланировано попыток: {n} из {max}',
    sharpenRunAll: '⚒️ Заточить всё',
    pickHint: 'зажмите предмет или сундук, чтобы выделить несколько',
    itemSharpened: '✨ Заточен: +{n} шагов сверх выпавших',
    itemSocketed: '💎 Самоцветов вставлено: {n} из {max}',
    // СОКЕТЫ (этап Э4): гнездо пробивается резцом, самоцвет даёт статы по своему виду и размеру
    socketsTitle: 'Гнёзда под самоцветы',
    socketsPunched: 'пробито {n} из {max}',
    socketsNote: 'Гнёзда пробиваются резцом ОДНИМ броском и один раз на предмет: сколько их выйдет — дело удачи. Вставленный самоцвет даёт характеристики по своему виду и размеру.',
    socketOpen: 'Пробить гнёзда',
    socketOdds: 'Шансы броска (сколько гнёзд):',
    socketReroll: 'Пересбросить гнёзда',
    socketRerollGo: 'Пересбросить',
    socketRerollWarn: 'Гнёзда будут пробиты заново, и их может стать МЕНЬШЕ, чем сейчас. Отменить это нельзя.',
    socketRerollGems: 'Сначала извлеките самоцветы: пересброс переберёт гнёзда заново.',
    socketEmpty: 'Пустое гнездо',
    socketChoose: 'Какой самоцвет вставить:',
    socketNoGems: 'Подходящих самоцветов нет.',
    socketExtract: 'Извлечь самоцвет',
    socketExtractBurn: 'При извлечении самоцвет сгорает, гнездо останется пустым.',
    socketExtractBack: 'Самоцвет вернётся в ваш запас, гнездо останется пустым.',
    socketCatTitle: 'Что дают самоцветы в этом предмете:',
    socketExtractFree: 'Извлечение бесплатно.',
    itemPower: 'Сила предмета',
    socketClassOnly: 'Только в классовой амуниции: {list}. В обычных вещах камень их не даёт.',
    improveTitle: 'Улучшение амуниции',
    tabSharpen: 'Заточка',
    tabReplace: 'Трансформация',
    tabSockets: 'Гнёзда',
    replaceNote: 'Замена меняет характеристику на другую случайную. Срабатывает всегда, шагов переносится {keep}%.',
    replaceNone: 'У этого предмета нет характеристик, которые можно заменить: постоянные определяют суть вещи.',
    replaceKeeps: 'останется шагов: {n}',
    replaceOdds: 'Шансы выпадения характеристик:',
    socketNoneYet: 'Гнёзд пока нет — пробейте их резцом.',
    socketOpened: 'Пробито гнёзд: {n}',
    socketRerolled: 'Пересброс: было {was}, стало {n}',
    socketInserted: 'Вставлен {gem}',
    socketBurned: 'Самоцвет извлечён и сгорел ({gem})',
    socketTakenBack: 'Самоцвет извлечён и вернулся в запас ({gem})',
    replaceGo: 'Заменить',
    replaceAsk: 'Заменить «{stat}» на другую случайную характеристику? Отменить это нельзя, а шагов останется {keep} из {steps}.',
    replacePick: 'Нужная характеристика:',
    replaceAny: 'Любая (одна замена)',
    replaceTries: 'Попыток:',
    sharpenNotAll: 'На все попытки не хватит: {list} — сервер остановится, когда они кончатся.',
    spendTotal: 'Спишется:',
    replaceUpTo: 'Спишется не больше:',
    replaceRunAuto: 'Подбирать',
    replaceHit: 'Подобрано: {stat} (попыток: {n})',
    replaceMiss: 'За {n} попыт. {stat} не выпала',
    replaceConfirm: '🔮 Заменить характеристику',
    replaceDone: 'Характеристика заменена: «{from}» → «{to}»',
    sharpenSummary: 'Попыток: {n}, удачных: {ok}. Предмет цел — за неудачи сгорели только реагенты.',
    sharpenStepShort: 'шаг {n}',
    statPermanent: 'Постоянная характеристика: её можно точить, но нельзя заменить',
    spentTotal: 'Всего вложено в предмет:',
    sharpenSpent: 'Списано:',
    sharpenOutOfReagents: 'Реагенты закончились — остановились на этом',
    sharpenOff: 'Заточка сейчас недоступна.',
    sharpenNone: 'У этого предмета нет характеристик, которые можно точить.',
    sharpenLocked: 'Заточить можно только предмет здоровой фигуры и вне партии.',
    disasmEnergyRange: '⚡ Энергия гарантированно: {min}–{max}',
    disasmRefund: 'В эту вещь вложены улучшения — вернётся от {min}% до {max}% потраченного на них.',
    disasmRefundBack: 'Вернулось вложенного ({pct}%):',
    disasmRefundBackAny: 'Вернулось вложенного:',
    disasmConfirm: 'Разобрать предмет?',
    disasmBatchConfirm: 'Разобрать выделенное — {n} предм.?',
    disasmBatchHammer: 'Уйдёт молотов: {n}. Молот даёт материалы и самоцветы.',
    disasmBatchTop: 'Среди выделенного есть {r} — вернуть предметы будет нельзя.',
    disasmFree: 'Разбор бесплатный',
    disasmResult: 'Разобрано! Получено:',
    disasmNothing: 'В этот раз ничего не выпало.',
    disasmNoData: 'Нет данных о разборе этого предмета.',
    disasmSelected: 'Разобрать выделенное (молотов уйдёт: {n})',
    disasmCancel: 'Отменить разбор',
    disasmQuick: 'Мульти-разбор молотами (есть: {n}): 1 молот = 1 предмет. Нажмите 🔨, выделите предметы и нажмите 🔨 ещё раз. В отличие от обычного разбора даёт материалы и самоцветы, а не только энергию',
    disasmBatchMax: 'За один раз можно разобрать не больше {n} предметов',
    disasmLockedItem: 'Этот предмет сейчас заблокирован — в массовый разбор он не идёт',
    disasmSharpenedItem: 'Заточенный предмет в массовый разбор не идёт — разберите его по одному',
    disasmSocketedItem: 'В предмете есть гнёзда — разберите его по одному, чтобы вернуть самоцветы',
    disasmChestOnly: 'Молотом разбираем только из сундука — сначала сгрузите предмет туда',
    disasmLimit: 'Молотов хватает только на {n} предм. — купите молоты на Рынке',
    withHammer: 'С молотом кузнеца (1 молот за предмет):',
    disasmNoHammer: 'Нужен молот кузнеца — купите его на Рынке (вкладка «Инструменты»)',
    disasmOnlyEnergy: 'Без молота выпадает только энергия. Материалы и самоцветы даёт разбор молотом.',
    disasmGuarantee: 'Пустого разбора не бывает: если ролл не прошёл, придёт минимум — энергия при поштучном, материалы при разборе молотом.',
    dropAlways: 'всегда',
    youGet: 'Вы получите:',
    emptySlot: 'Пусто — перетащи сюда предмет из инвентаря фигуры',
    ok: 'Ок',
    cancel: 'Отмена',
    recharge: '⚡ Зарядить',
    rechargeItem: '⚡ Перезарядить ({price}/заряд)',
    rechargeHint: '{price}⚡ за заряд; не хватит энергии — восстановим сколько можем',
    rechargeFrac: 'Зарядить классовые предметы {fraction}?',
    rechargeTotal: 'Всего: {total}⚡ · баланс {balance}⚡',
    rechargeEtherAll: 'Или эфиром: до {n} зар. (эфир: {ether})',
    rechargeEtherAllBtn: 'Зарядить эфиром ({n})',
    rechargeRow: '+{n} зар. · {price}⚡',
    rechargeNotEnough: 'Энергии на всё не хватает — зарядим сколько можем.',
    rechargeAllFull: 'Все классовые предметы фракции заряжены полностью.',
    rechargeDone: 'Классовые предметы заряжены',
    chargesRestored: 'Заряды восстановлены',
    healAll: '✚ Восстановить всех',
    healFrac: 'Восстановить фигуры {fraction}?',
    healTotalCost: 'Общая стоимость восстановления всех:',
    healBalance: 'Баланс энергии: {balance}⚡. Не хватит ресурсов на всех — восстановим кого сможем.',
    healFree: 'Восстановление бесплатно (таймеры истекли).',
    healBoostHint: 'Пески времени: {n} мин в запасе — перемотают таймеры всей фракции',
    healTotalTime: 'Полное восстановление песками: {n} мин',
    healBoostAll: 'Ускорить песками',
    hospitalHint: 'Полное исцеление армии: {n} шт. — поднимет ВСЕ фигуры обеих фракций разом',
    hospitalUse: 'Исцелить армию',
    hospitalDone: 'Армия поднята: {n} фигур',
    healBoostDone: 'Готовы: {n} · потрачено минут: {m}',
    healUnit: 'Вылечить фигуру?',
    reviveUnit: 'Оживить фигуру?',
    heal: 'Вылечить',
    revive: 'Оживить',
    healed: 'Вылечено',
    revived: 'Оживлено',
    unitsRestored: 'Фигуры восстановлены',
    unitsRestoredPart: 'Восстановлено {done} из {total} — на остальных не хватило ресурсов',
    unitsRestoreNone: 'Не хватает ресурсов для восстановления',
    freeIn: 'Бесплатно через {time}',
    instantFor: 'Мгновенно за:',
    matchInProgressAmmo: 'Идёт партия — амуницию менять нельзя',
    matchInProgressHeal: 'Идёт партия — восстанавливать нельзя',
    matchFinished: 'Партия завершена',
    unitDeadAmmo: 'Фигура мертва — амуниция заблокирована до оживления',
    unitDeadInv: 'Фигура мертва — инвентарь заблокирован',
    unitWounded: 'Фигура ранена — сначала вылечите её',
    restoreFirst: 'Сначала восстановите фигуру',
    notForThisUnit: 'Не подходит этой фигуре',
    swapSameType: 'Менять местами можно только фигуры одного типа',
    unitsSwapped: 'Фигуры переставлены',
    swapFractionsTitle: 'Обмен амуницией',
    swapFractions: 'Поменять всю амуницию местами между Эльфами и Зомби?',
    swapFractionsOk: 'Поменять',
    fractionsSwapped: 'Амуниция фракций поменяна местами',
    inventoriesUnloaded: 'Инвентари выгружены в сундук',
    notEnoughEnergyRecharge: 'Не хватает энергии для перезарядки',
    error: 'Ошибка',
    energyToBalance: 'Энергия (в баланс)',
    energyFromBalance: 'Энергия (из баланса)',
    energy: 'энергия',
    material: 'Материал (дерево/камень/железо)',
    gemLine: 'Самоцвет ({size})',
    dropNote: 'Каждая строка выпадает независимо; вид материала и самоцвета — случайный.',
    tipBalance: 'Баланс энергии: можно тратить (разбор, лечение). Пополняется энергией из партий',
    tipHasBox: 'В инвентаре фигуры лежит сундук с добычей',
    tipHasAmmo: 'В инвентаре есть амуниция',
    tipUnload: 'Выгрузить амуницию из инвентарей всех фигур в сундук',
    tipSell: 'Выставить на Рынок за энергию',
    tipHealAll: 'Оживить/вылечить всех раненых и павших фигур фракции',
    tipRechargeAll: 'Перезарядить все классовые предметы фракции',
    tipSwapFractions: 'Поменять всю амуницию местами между фракциями',
    tipUnequipAll: 'Снять всю амуницию в инвентарь',
    tipToChest: 'Убрать всё в сундук',
    weapon: 'Оружие',
    shieldQuiver: 'Щит/Колчан',
    classItem: 'Классовый',
    spellbookItem: 'Книга заклинаний',
    cloakItem: 'Плащ невидимости',
    player: 'Игрок',
    levelShort: 'ур.',
  },
  game: {
    charges: 'Заряды: {left}/{max}',
    recharge: 'Перезарядка: {n} р.',
    regenHp: '{n} к реген. HP {suffix}',
    regenMana: '{n} к реген. маны {suffix}',
    regenStamina: '{n} к реген. выносл. {suffix}',
    roundsShort: 'р',
    errorCode: 'Ошибка {code}',
    costMana: '{n} маны',
    costStamina: '{n} выносл.',
    costHealth: '{n} HP',
    costLabel: 'Цена: {parts}',
    stats: 'Характеристики:',
    noBonuses: 'нет бонусов',
    noData: 'нет данных',
    minLevel: 'Мин. ур.: {n}',
    opensAbility: 'Открывает способность:',
    abilityCharges: 'Заряды способности',
    equipment: 'Экипировка',
    backpack: 'Рюкзак',
    history: 'История ходов',
    logSkip: 'пас',
    piece: {
      King: 'Кр', Queen: 'Ф', Rook: 'Л', Bishop: 'С', Knight: 'К', Pawn: '',
    },
    fullscreen: 'Во весь экран',
    classicFigures: 'Классические фигуры',
    styledFigures: 'Стилизованные фигуры',
    viewFrom: 'Смотреть со стороны {side}',
    sideElf: 'эльфов',
    sideZombie: 'зомби',
    hoverUnit: 'Наведите на фигуру',
    level: 'Уровень {n}',
    power: 'Сила',
    buffs: 'Баффы',
    debuffs: 'Дебаффы',
    inventory: 'Инвентарь',
    whatSkill: 'Что делает навык',
    whatAbility: 'Что делает способность',
    soilDrains: 'Почва под королём иссушает ману в начале хода — на навык не хватит',
    soilAnnihilated: 'Почвы столкнулись и уничтожили друг друга — клетка очищена',
    castImmune: 'Короля и ферзя соперника магия не берёт — выбери другую вражескую фигуру',
    techDefeatIn: 'Техническое поражение через:',
    techDefeatOppIn: 'Техническое поражение соперника через:',
    selfPlayNoReward: 'Игра с самим собой — награды не начисляются',
    armyNotReady: 'Армия ещё не восстановлена — вылечите фигуры в «Настройках фигур»',
    waitingOpponent: 'Ожидание соперника',
    // Окно итогов партии (пересобрано 2026-09-05): исход словом + добыча за всю партию
    resWin: 'Победа!',
    resLose: 'Поражение',
    resDraw: 'Партия завершена',
    resWinnerIs: 'Победили {side}',
    resWinnerLine: '{side} · {name}',
    resNoWinner: 'Победитель не определён',
    resYou: 'вы',
    resWinnerTag: 'Победитель',
    resKilled: 'Фигур срублено',
    resEnergy: 'Энергия за партию',
    resRating: 'Рейтинг',
    lootTitle: '🎁 Ваша добыча за партию',
    lootSide: '🎁 Добыча: {side}',
    lootEmpty: 'За эту партию добычи не было',
    fightResult: 'Итоги поединка',
    surrender: 'Сдаться',
    surrenderConfirm: 'Сдаться? Вам засчитается поражение в этой партии.',
    toLobby: 'В лобби',
    exit: 'Выйти',
    spectator: '👁 Зритель',
    spectatorsWatch: 'Зрителей смотрит',
    like: 'Поставить лайк',
    close: 'Закрыть',
    chooseCell: 'выберите клетку',
    chooseTarget: 'выберите цель',
    chooseSpell: 'выберите заклинание',
    itemLost: 'Предмет потерян (инвентарь полон)',
    dropBox: '{rarity} сундук — ждёт в инвентаре фигуры',
    noQueue: 'К сожалению, сейчас нет игроков в очереди ожидания.',
    noQueueHint: 'Попробуйте сменить фракцию или активировать бота.',
    promotePawn: 'Превратить пешку в павшего союзника',
    decideLater: 'Решить позже',
    protection: 'Защита',
    miss: 'Промах',
    perRound: 'р.',
    perTurn: 'р./ход',
    duration: 'Действие: {n} {unit}',
    dispel: 'Снимает вражеские заклинания с цели — вместе с усилением, которое они дают врагу',
    self: 'Себе',
    target: 'Цели',
    spellHeal: 'Лечение',
    spellLightning: 'Молния',
    spellStrength: 'Сила',
    spellWeakness: 'Слабость',
    spellCleanse: 'Очищение',
    spellVampirism: 'Вампиризм',
    gem: 'Самоцвет',
    gemSmall: 'малый',
    gemMedium: 'средний',
    gemLarge: 'крупный',
  },
  shop: {
    itemLine: '{rarity} предмет (ур. {level})',
    title: 'Магазин амуниции',
    empty: 'Магазин пуст.',
    balance: 'Баланс энергии:',
    buy: 'Купить · {price} ⚡',
    note: 'Выпадает случайный предмет выбранной редкости под ваш уровень фигур — в сундук.',
    got: 'Получено:',
    lost: 'предмет потерян (хранилище переполнено)',
    errBuy: 'Не удалось купить.',
  },
  res: {
    topaz: 'Топазы',
    ruby: 'Рубины',
    sapphire: 'Сапфиры',
    diamond: 'Бриллианты',
    topazOne: 'топаз',
    rubyOne: 'рубин',
    sapphireOne: 'сапфир',
    diamondOne: 'бриллиант',
    wood: 'Дерево',
    stone: 'Камень',
    iron: 'Железо',
    woodOne: 'дерево',
    stoneOne: 'камень',
    ironOne: 'железо',
    sizeS: 'Малый',
    sizeM: 'Средний',
    sizeL: 'Большой',
    sizeU: 'Уникальный',
    sizeLeg: 'Легендарный',
    sizeSlow: 'малый',
    sizeMlow: 'средний',
    sizeLlow: 'большой',
    sizeUlow: 'уникальный',
    sizeLeglow: 'легендарный',
  },
  // ─── Экран «Справка» (пункт меню после обучения): темы + перепройти акт ───
  help: {
    title: 'Справка',
    subtitle: 'Как всё устроено — и как перепройти любую часть обучения',
    restartTitle: 'Пройти обучение заново',
    restartHint: 'Начать весь гайд с самого начала — наставник снова проведёт по всем шагам. Подходит и тем, кто играет давно. Награды за уже пройденное повторно не выдаются. Пройти заново можно только один раз.',
    restartBtn: 'Пройти заново',
    restartUsed: 'Этот заход уже использован: обучение проходят заново только один раз. Отдельную часть можно перепройти сколько угодно — ниже.',
    replayTitle: 'Перепройти обучение',
    replayHint: 'Выбери часть — наставник проведёт по ней заново. Награды за неё уже получены и повторно не выдаются.',
    wikiTitle: 'Подробная вики',
    wikiHint: 'Полные таблицы предметов, навыков и формул — во внешней вики проекта.',
    topic: {
      board: {
        title: 'Доска',
        l1: 'Фигуры ходят как в шахматах, но взятие запускает поединок — победитель занимает клетку.',
        l2: 'Цель партии — убить короля соперника, а не поставить мат.',
        l3: 'Таймеров два: общий на партию и короткий на ход. Не успел — ход сгорает.',
        l4: 'Король умеет колдовать прямо с доски, не сходя с места.',
        l5: 'Раненые фигуры сами не лечатся — их восстанавливают в «Настройках фигур».',
      },
      fight: {
        title: 'Поединок',
        l1: 'Сетка 4×4: воинов ставят вперёд, лучников и магов прячут за ними.',
        l2: 'Первую линию бьют только воины; лучники и маги достают любой ряд.',
        l3: 'Порядок ходов — по инициативе, лента очереди видна слева.',
        l4: 'Обычная атака ресурсов не тратит: навыки воинов стоят выносливости, магов — маны, лучников — и того, и другого.',
        l5: 'Классовый предмет даёт способность и тратит заряд — заряды восстанавливаются за энергию или эфир.',
      },
      army: {
        title: 'Армия',
        l1: 'У каждой фигуры свой подкласс: Воин, Лучник или Маг — под него и подбирают амуницию.',
        l2: 'Пока предмет лежит в сундуке, он не работает: сила растёт только от надетого.',
        l3: 'Сила армии — сумма сил фигур; по ней подбирается соперник.',
        l4: 'Свитки подбирают амуницию сами: подмастерья — на одну фигуру, мастера — на всю сторону.',
        l5: 'Инвентарь фигуры и общий сундук — разные места: добычу удобно сгружать одной кнопкой.',
      },
      economy: {
        title: 'Экономика',
        l1: 'Энергия — это рейтинг; тратится баланс, накопленный сверх него.',
        l2: 'Материалы и самоцветы дают разбор предметов и задания дня.',
        l3: 'Лечение и оживление стоят ресурсов и времени; пески времени перематывают таймер.',
        l4: 'Молот кузнеца нужен для мульти-разбора: он и приносит материалы с самоцветами.',
        l5: 'Лишнее продаётся другим игрокам на рынке за энергию.',
      },
      meta: {
        title: 'Соревнование',
        l1: 'Задания дня дают сундук за 100 очков, а серия дней — сундук недели.',
        l2: 'Колесо фортуны крутится за билеты: их дают задания, друзья и лавка.',
        l3: 'Допуск по силе решает, насколько ровного соперника искать.',
        l4: 'В турнире отдельный профиль: своя армия и своя таблица, фигуры туда не переносятся.',
        l5: 'За приглашённых друзей начисляются билеты, а чужие партии можно смотреть глазом наблюдателя.',
      },
    },
  },
  tut: {
    tag: 'Обучение',
    hide: 'Скрыть подсказку',
    hideHint: 'Убрать подсказку',
    act0: 'Вход в мир',
    act1: 'Первая партия',
    stepOf: 'шаг {n} из {total}',
    stopOf: 'остановка {n} из {total}',
    next: 'Дальше',
    gotIt: 'Понятно',
    skip: 'Пропустить',
    skipAll: 'Пропустить обучение',
    tourDone: 'В армию',
    mentorElf: 'Фанилуана, наставница',
    mentorZombie: 'Бессмертная королева, наставница',
    buttonActive: 'Обучение',
    buttonResume: 'Продолжить обучение',
    buttonHelp: 'Справка',
    lockedHint: 'откроется после первой партии',
    factionTitle: 'Выбери сторону',
    factionSub: 'За кого играешь — тем и собираешь армию',
    factionElf: 'Живые и быстрые. Ходят первыми чаще, лечат своих и бьют точнее.',
    factionZombie: 'Мёртвые и живучие. Держат удар, ослабляют врага и давят числом.',
    factionSay: 'Добро пожаловать. Выбери сторону — и я покажу, как здесь сражаются.',
    chosen: 'выбрано',
    playAs: 'За {side}',
    giftTitle: 'Дар наставника',
    giftSub: 'Два предмета, которые пригодятся уже в первом бою',
    giftSay: 'Это не украшения. В поединке они дают способности — сейчас наденем их на фигуры.',
    giftFor: 'носит {unit}',
    giftNext: 'Показать игру',
    tourPvp: 'Здесь начинаются партии с живыми игроками.',
    tourTournaments: 'Отдельные соревнования с равным стартом для всех.',
    tourLearn: 'Сюда можно вернуться в любой момент и продолжить обучение.',
    equipHint: 'Перетащи дар в подсвеченный слот — это слот классового предмета.',
    equipDone: 'Дар надет! Сила фигуры выросла — теперь в бой.',
    hintSelect: 'Нажми фигуру — увидишь, куда она может пойти',
    hintTimer: 'На каждый ход есть время. Не успел — ход сгорает',
    hintAttack: 'Атакуй фигуру соперника — начнётся поединок',
    hintAfterFight: 'Раненые сами не лечатся — вылечишь их в «Настройках фигур»',
    hintWin: 'Цель партии — убить короля соперника',
    // ─── Акт 2 «Твоя армия» ───
    act2: 'Твоя армия',
    later: 'Позже',
    armyChestTitle: 'Хранилище',
    armyChest: 'Пока предмет лежит в сундуке, он не работает',
    armyEquipTitle: 'Экипировка',
    armyEquip: 'Перетащи добычу в слот — сила фигуры вырастет',
    armyHealTitle: 'Лечение',
    armyHeal: 'Раненые сами не лечатся. Нажми ⛑ и подними армию — без этого в новый бой её не отправить',
    armyResTitle: 'Ресурсы',
    armyRes: 'Материалы и самоцветы дают разбор и задания дня',
    armyDisasmTitle: 'Разбор',
    armyDisasm: 'Ненужное разбирается на ресурсы. Молот даёт больше',
    armyWheelTitle: 'Колесо фортуны',
    armyWheel: 'Билет уже у тебя — крути. На колесе выпадают ресурсы и амуниция вплоть до эпической; билеты дают задания дня, друзья и лавка',
    // ─── чек-лист «Путь новичка» ───
    pathTitle: 'Путь новичка',
    pathClaim: 'Забрать',
    pathGot: 'Получено:',
    pathDone: 'Пункт «Пути новичка» выполнен — награда ждёт в профиле',
    // ─── второй заход обучения (2026-07-29) ───
    equipBridleHint: 'Перетащи Уздечку в жёлтый слот коня — в поединке он получит лишний ход',
    pickFigureTitle: 'Выбери фигуру',
    pickPawn: 'Нажми эту пешку — на неё наденем Бутылёк',
    pickKnight: 'Теперь конь: нажми его — ему достанется Уздечка',
    swapTitle: 'Центр расстановки',
    swapHint: 'Перетащи пешку с Бутыльком на {cell} — в центр своего ряда. Фигуры просто меняются местами',
    swapDone: 'Пешка с Бутыльком в центре',
    dailyOpenTitle: 'Задания дня',
    dailyOpen: 'Отсюда, из профиля, открываются задания дня — запомни дорогу, заходить будешь каждый день',
    dailyOpenGo: 'Открыть задания',
    dailyTitle: 'Задания дня',
    dailyHint: 'Каждый день новые задания и сундук за 100 очков. Забери первую награду — и в бой',
    toBattle: 'В бой',
    dailyAfter: 'Партия засчитана в задания. Забери награды — и вернёмся к армии',
    dailyClaimFirst: 'Забрать награды',
    toPack: 'В настройки фигур',
    pvpToBattleTitle: 'В бой!',
    pvpToBattle: 'Теперь всё готово. Жми «В бой» — я подберу тебе соперника и буду рядом всю партию',
    pvpToPackTitle: 'Приведи армию в порядок',
    pvpToPack: 'После боя фигуры ранены. Открой «Настройки фигур» — вылечим армию и разберёмся с добычей',
    pvpLock: 'Первая партия — за {side}: на этих фигурах дар наставника',
    tourInGame: 'осмотрись в партии',
    armyUnloadTitle: 'Добыча в инвентарях',
    armyUnload: 'После партии добыча лежит в инвентарях фигур. Кнопка ▼ сгружает всё в общий сундук',
    armyRechargeTitle: 'Перезарядка зарядов',
    armyRecharge: 'Кнопка ⚡ перезаряжает классовые предметы: заряды тратятся в бою, а без них способность не сработает. Платить можно энергией или эфиром. Перезаряди — и получишь награду',
    armySwapTitle: 'Обмен между фракциями',
    armySwap: 'Кнопка ⇄ меняет амуницию местами между твоими эльфами и зомби — одна армия отдаёт снаряжение другой. Поменяй — и получишь награду',
    mktTabsTitle: 'Рынок',
    mktTabs: 'Здесь торгуют между собой игроки. Четыре вкладки: «Купить», «Мои лоты», «Выставить» и «Магазин». Пройдёмся по каждой',
    mktBuyTitle: 'Купить',
    mktBuy: 'Тут лоты других игроков. Фильтры и сортировка сверху сужают поиск. Цена — в энергии ⚡ (иногда с доплатой ресурсами); кнопка «Купить» забирает лот себе',
    mktSellTitle: 'Выставить на продажу',
    mktSell: 'Продавать за энергию можно амуницию и ресурсы. На продажу идёт ТОЛЬКО амуниция из инвентаря фигуры, общего сундука или со склада наград — надетую сначала сними. Нажми на предмет, задай цену — и лот на рынке',
    mktMineTitle: 'Мои лоты',
    mktMine: 'Твои активные продажи. Кнопка «Снять» убирает лот с рынка и возвращает предмет тебе',
    mktShopTitle: 'Магазин',
    mktShop: 'Здесь бусты (пески времени, свитки автоподбора) продаёт сама игра — за ресурсы, а не за энергию',
    mktWarnTitle: 'Играй честно',
    mktWarn: '⚠️ Рынок под присмотром: перепродажа самому себе и любые махинации с ценами караются — аккаунт могут заблокировать',
    armyHealWays: 'Лечить можно двумя способами: заплатить ресурсами и энергией — фигуры встанут сразу, или ускорить восстановление песками времени',
    // ─── Акт 3 «Цикл дня» (второй заход) ───
    act3: 'Цикл дня',
    day2WelcomeTitle: 'С возвращением',
    day2Welcome: 'Возвращаться каждый день выгодно: держи билет колеса. Покажу, из чего состоит игровой день',
    day2ToDaily: 'В задания дня',
    day2StreakTitle: 'Серия и неделя',
    day2Streak: 'Каждый день с заданиями продлевает серию, а 5 дней из 7 дают сундук недели и поднимают тир наград',
    day2ToWheel: 'К колесу',
    day2WheelTitle: 'Колесо фортуны',
    day2Wheel: 'Билет уже у тебя — крути. Билеты дают задания, друзья и лавка',
    // ─── Акт 4 «Соревнование» ───
    act4: 'Соревнование',
    compDevTitle: 'Допуск по силе',
    compDev: 'Узкий допуск — соперник ровно твоей силы, но искать дольше. Широкий — быстрее, но бой тяжелее',
    compBoardTitle: 'Таблица лидеров',
    compBoard: 'Рейтинг — это накопленная энергия. Глазик у ника открывает армию игрока',
    compSpectateTitle: 'Наблюдатель',
    compSpectate: 'Здесь видно живые партии: заходи смотреть и учись у сильных',
    compSeasonTitle: 'Турниры',
    compSeason: 'В турнире отдельный профиль: своя армия и своя таблица. Твои фигуры туда НЕ переносятся',
    compRefTitle: 'Приглашай друзей',
    compRef: 'За каждого друга — билеты колеса. Ссылка выше, она твоя навсегда',
    compDone: 'Готово',
    profileTitle: 'Профиль',
    profileOpen: 'Нажми «Профиль» — рассказываю дальше уже внутри',
    profileGo: 'Зайти в профиль',
    profileTourTitle: 'Что в профиле',
    profileTour: 'Здесь рейтинг и запас ресурсов, вход в задания дня, колесо, рынок и «Настройки фигур». Идём в настройки фигур — оденем армию',
    profileToPack: 'В настройки фигур',
    waitTitle: 'Ждём соперника',
    waitFullscreen: 'Пока ищем соперника — разверни игру на весь экран, так удобнее',
    gamePickTitle: 'Выбери фигуру',
    gamePick: 'Нажми пешку с Бутыльком — тогда в «Рюкзаке» будет видна её амуниция',
    tourInFight: 'поединок',
    fightStandTitle: 'Расстановка',
    fightStand: 'Воинов — в первый ряд: только они держат удар. Лучников и магов прячь за ними',
    fightOrderTitle: 'Очередь ходов',
    fightOrder: 'Слева лента очереди: у кого выше инициатива, тот ходит раньше',
    fightHitTitle: 'Ход завершает атака',
    fightHit: 'Ход заканчивается атакой, защитой или временем. Атакуй фигуру соперника',
    fightSkillTitle: 'Навыки и способности',
    fightSkill: 'Навык и классовая способность ход НЕ тратят — применяй их до атаки. Кнопка «i» рядом покажет описание',
    fightAbilityTitle: 'Способность дара',
    fightAbility: 'У этой фигуры есть способность предмета — примени её, ход на это не уйдёт',
    kingCastTitle: 'Каст короля',
    kingCastPick: 'Нажми на своего короля — он умеет колдовать прямо на доске',
    kingCastPickFoe: 'Нажми на своего короля — он умеет колдовать прямо на доске. Заклинание бьёт по врагу, но короля и ферзя соперника магия не берёт',
    // 🔴 «РАСХОДУЕТ ход» — это правило сервера (`cast_skill` заканчивается `set_match_turn`).
    // Прежний текст говорил «каст не отменяет твой ход», то есть подсказка обучения врала про
    // механику; английский текст всё это время был правильным (найдено разбором 2026-08-25).
    kingCast: 'Вот кнопка навыка во вкладке «Меч». Нажми её и выбери цель — каст РАСХОДУЕТ твой ход, как обычный ход фигурой. Навык короля нельзя применить на вражеских короля и ферзя (они невосприимчивы к магии на доске)',
    tourFiguresTitle: 'Фигуры с даром',
    tourFigures: 'Вот они: пешка с Бутыльком и конь с Уздечкой. В поединке у них появятся способности',
    tourPackTitle: 'Рюкзак',
    tourPack: 'Рюкзак показывает надетую амуницию и инвентарь фигуры — 14 ячеек. Переполнится — фигура перестанет собирать трофеи с убитых',
    tourSwordTitle: 'Меч',
    tourSword: 'Меч — характеристики фигуры, а ниже видно наложенные бафы и дебафы с оставшимися раундами',
    tourTimersTitle: 'Два таймера',
    tourTimers: 'Время всей партии и время хода. Пока читаешь подсказку, оба стоят',
    tourEnergyTitle: 'Энергия сторон',
    tourEnergy: 'Сверху — иконки сторон: подсвеченная показывает, чей сейчас ход. Рядом счётчик энергии: сколько сторона набрала за убитые фигуры. Энергия — это рейтинг',
    tourMiniTitle: 'Мини-доска',
    tourMini: 'Внизу вся позиция целиком, а кнопка над ней меняет вид фигур',
    gameDefendersTitle: 'Кто вступит в бой',
    gameDefenders: 'При атаке фигуры в поединок вступает не только она, но и ВСЕ её защитники. Выбери свою фигуру — клетки всех, кто может вступить в поединок, подсветятся оранжевым. Всегда смотри на защитников: атаковать фигуру под прикрытием нескольких защитников — рискованно.',
    rollTitle: 'Награда за шаг',
    rollSub: 'Ролл рулетки',
    rollGot: 'Получено: {reward}',
    path: {
      win_pvp: 'Победить игрока',
      equip_5: 'Надеть 5 предметов',
      heal_unit: 'Вылечить фигуру',
      disassemble: 'Разобрать предмет',
      daily_chest: 'Забрать сундук дня',
      market_visit: 'Изучить рынок',
      market_sell: 'Выставить лот на рынке',
      wheel_spin: 'Крутануть колесо фортуны',
      invite_friend: 'Пригласить друга',
    },
    helpTitle: 'Как это сделать',
    pathHelpHint: 'Нажми — наставник покажет, где это делается',
    help: {
      win_pvp: 'Выбери сторону и жми «Старт». Пункт закроется победой над игроком или сложным ботом (лёгкий бот не считается)',
      equip_5: 'Открой сундук, перетащи предметы в слоты фигур. Нужно надеть пять любых предметов',
      heal_unit: 'Кнопка ⛑ у своей армии: заплати ресурсами или ускорь восстановление песками времени',
      disassemble: 'Кнопка 🔨 разбирает лишнее на ресурсы. Один молот — один предмет',
      wheel_spin: 'Нажми «Крутить»: билеты дают задания дня, друзья и лавка на рынке',
      daily_chest: 'Набери 100 очков за задания дня — сундук откроется сам, а награду забери здесь',
      market_visit: 'Просто загляни на рынок — наставник покажет, что там есть',
      market_sell: 'Вкладка «Выставить»: выбери предмет или ресурс, назначь цену в энергии и выстави лот',
      invite_friend: 'Скопируй свою ссылку и позови друга — за его первую партию придут билеты',
    },
  },
  daily: {
    doneInMatch: 'выполнено',
    doneClaimed: 'выполнено · награда получена',
    readyTake: 'выполнено — забери награду',
    rewardQuest: 'Награда за задание',
    rewardChest: 'Добыча из сундука',
    rewardNote: 'Всё уже начислено — предметы ищи в сундуке и на фигурах',
    rewardNotePick: 'Осталось выбрать предмет — он и вся остальная награда уедут одним сундуком',
    pickWaiting: 'Ждёт твоего выбора',
    rewardOk: 'Забрать',
    peekNote: 'Что лежит в сундуке этого дня',
    inMail: 'ждёт в почте',
    boxNote: 'Лежит в вашем сундуке, откроется через {time}',
    openChest: 'Открыть сундук дня',
    later: 'Позже',
    ok: 'Ок',
    retry: 'Повторить',
    authExpired: 'Сессия не подтверждена — войдите в игру заново.',
    serverError: 'Сервер не ответил. Повторите попытку.',
    itemLevel: 'уровень {n}',
    overflowTitle: 'Второй сундук — за перевыполнение (каждые {n} очков сверх нормы):',
    title: 'Задания дня',
    subtitle: 'Шесть заданий на {total} очков — набери любые {need} и открой сундук',
    dayEndsIn: 'день сменится через',
    streakBurns: 'серия сгорит через',
    weekTitle: 'Неделя · тир {tier} из {max}',
    weekTierHint: 'Тир задаёт качество предмета за пятницу и воскресенье. Неделя выполнена — тир поднимается на ступень, провалена — опускается на одну. С верхней ступени лестница начинается заново.',
    weekTierTop: '⭐ Верхняя ступень: в пятницу и воскресенье придёт уникальный классовый предмет. Со следующей недели лестница начнётся заново.',
    streakDays: 'серия {n} дн.',
    forWeekChest: 'до сундука недели',
    insuranceReady: 'страховка: не потрачена',
    insuranceUsed: 'страховка: потрачена',
    chestOf: 'Сундук {day}',
    chestSurprise: 'сюрприз',
    routesLeft: 'До сундука {n} очков — хватит любого пути:',
    routesDone: 'Сундук дня открыт — дальше идут бонусные билеты:',
    leftShort: 'До сундука {n} очков',
    chestOpen: 'Сундук дня открыт',
    routeHard: 'одно сложное',
    routeMix: 'среднее + лёгкое',
    routeEasy: 'два лёгких',
    claim: 'Забрать',
    claimAll: 'Забрать всё ({n})',
    rerollHint: 'Заменить задание (осталось замен сегодня: {n})',
    rerollConfirm: 'Точно?',
    monthTitle: 'Веха месяца',
    monthPeek: 'что дают',
    monthProgress: 'Активных дней: {have} из {need}',
    monthChoiceTitle: 'Выбор из {n} — заберёшь один',
    monthChoiceEpic: 'С шансом {pct}% один из вариантов будет эпическим',
    monthNote: 'Дни в любом порядке · уникальный классовый + билеты',
    monthReady: 'Веха закрыта — забери награду',
    rewardMonth: 'Веха месяца закрыта!',
    weekChestTitle: 'Сундук недели',
    weekChestNote: 'Приходит в воскресенье · собрано дней: {have} из {need}',
    weekChestWhen: 'Он приходит СВЕРХ сундука дня — отдельным сундуком в хранилище.',
    weekChestTier: 'Ступень {tier} из {max} решает качество предметов за пятницу и воскресенье.',
    pickWhere: 'Выбранное и остальная награда уедут одним сундуком в хранилище — сундук откроется по таймеру.',
    pickConfirmOne: 'Забрать: {name}',
    daysShort: 'дн.',
    mailTitle: 'Склад наград',
    mailWaiting: 'Ждёт наград: {n}',
    mailEmpty: 'Пусто — всё выдано',
    mailKeepHint: 'Награды ждут здесь сколько угодно — забирай, когда пригодятся',
    mailHospital: 'Полное восстановление армии',
    hospitalNote: 'Применить можно в «Настройках фигур» — поднимет всю армию',
    mailClassItem: 'Классовый предмет на выбор',
    mailItem: 'Предмет амуниции',
    mailSource: { week_chest: 'Сундук недели', month: 'Веха месяца', day_chest: 'Сундук дня', overflow: 'Сундук за перевыполнение' },
    toBattle: 'В бой',
    toPack: 'Настройки фигур',
    toBattleLeft: 'В бой — осталось {n} очков',
    ctaNote: 'Партии сверх заданий приносят лут, энергию и рейтинг как обычно.',
    pickTitle: 'Выбери награду',
    pickNote: 'Заберёшь один из вариантов — выбор за тобой',
    pickConfirm: 'Забрать выбранное',
    levelShort: 'ур. {n}',
    // Категория предмета в описании выбора: «эпическое ОРУЖИЕ», «уникальный КЛАССОВЫЙ ПРЕДМЕТ»
    cat: { any: 'предмет', class_item: 'классовый предмет', weapon: 'оружие', armor: 'броня', jewelry: 'украшение' },
    tier: {
      easy: 'лёгкое',
      mid: 'среднее',
      hard: 'сложное',
      elite: 'оч. сложное',
    },
    wd: {
      mon: 'пн', tue: 'вт', wed: 'ср', thu: 'чт', fri: 'пт', sat: 'сб', sun: 'вс',
    },
    wdFull: {
      mon: 'понедельника', tue: 'вторника', wed: 'среды', thu: 'четверга',
      fri: 'пятницы', sat: 'субботы', sun: 'воскресенья',
    },
    res: {
      box: 'сундук с таймером',
      energy: 'энергии',
      tickets: 'билета',
      gems_small: 'самоцвета',
      materials: 'материала',
      boost_minutes: 'минут ускорения',
      scroll_apprentice: 'свиток подмастерья',
      scroll_master: 'свиток мастера',
      ether: 'эфир',
      hammer: 'молот кузнеца',
      whetstone: 'инструмент для заточки',
      transform_stone: 'камень трансформации',
      chisel: 'резец',
      ammo: 'предмет амуниции',
      class_item: 'классовый предмет',
      choice: 'предмета на выбор',
      choicePick: 'Выбор из {n} предметов',
      hospital: 'полное исцеление армии',
    },
    q: {
      play_match_full: 'Сыграть партию целиком',
      wheel_spin: 'Крутануть колесо фортуны',
      disassemble_2: 'Разобрать 2 предмета',
      equip_item: 'Надеть предмет на фигуру',
      heal_unit: 'Вылечить фигуру',
      swap_positions: 'Переставить фигуру в расстановке',
      spectate_match: 'Посмотреть чужую партию как зритель',
      season_join: 'Зарегистрироваться на турнир',
      fight_loot_3: 'Получить 3 предмета в поединке',
      market_list: 'Выставить лот на рынке',
      win_match: 'Победить в партии',
      fight_streak_3: 'Выиграть 3 поединка',
      kill_5: 'Убить 5 фигур соперника',
      both_fractions: 'Сыграть за обе фракции',
      ability_2: 'Применить классовую способность 2 раза',
      revive_unit: 'Оживить фигуру',
      disassemble_5: 'Разобрать 5 предметов',
      referral_friend: 'Пригласить друга по рефералке',
      skills_4: 'Применить 4 навыка или способности',
      market_sold: 'Продать лот на рынке',
      king_spell_3: 'Применить заклинание короля 3 раза',
      win_2_matches: 'Победить в 2 партиях',
      fight_streak_6: 'Выиграть 6 поединков',
      win_flawless: 'Победить, не потеряв ни одной фигуры',
      king_before_20: 'Убить короля соперника до 20-го хода',
      equip_full_3: 'Полностью экипировать 3 фигуры',
      season_match: 'Сыграть турнирную партию',
      win_vs_stronger: 'Выиграть партию с соперником сильнее себя',
      promote_pawn: 'Превратить пешку',
    },
  },
  srvError: {
    cellTaken: 'Клетка занята — атакуйте фигуру, а не ходите на неё.',
    targetNotInFight: 'Эта фигура не участвует в поединке.',
    targetIsAlly: 'Атаковать можно только фигуру соперника.',
    noHealthForSkill: 'Не хватает здоровья на этот навык.',
      starsOff: 'Магазин временно недоступен',
      starsTgDown: 'Telegram сейчас не отвечает — попробуйте позже',
      starsNoProduct: 'Такого набора нет',
      starsBadProduct: 'Набор временно недоступен',
      starsPriceChanged: 'Цена изменилась — обновите магазин',
      starsBlacklisted: 'Покупки для этого аккаунта недоступны',
      starsRefundBlock: 'Покупки закрыты: по этому аккаунту слишком много возвратов. Напишите боту /paysupport',
      walletTaken: 'Этот кошелёк уже привязан к другому игроку',
      walletPayloadGone: 'Код привязки истёк — начните подключение заново',
      walletNeeded: 'Сначала привяжите кошелёк TON',
      noStockToReturn: 'Некого вернуть в состав вместо NFT-фигуры — сначала верните в запас свою фигуру этого класса',
      bakedFrozen: 'Комплект запечён на NFT — сначала разблокируйте фигуру',
      bakeNothing: 'На фигуре нет амуниции — запекать нечего',
      bakeAlready: 'Комплект этой фигуры уже запечён',
      bakeNotBaked: 'Комплект этой фигуры не запечён',
      noBalanceEnergy: 'Не хватает энергии в балансе',
      notNftUnit: 'Это не NFT-воин',
      bakeOnMarket: 'Часть комплекта выставлена на Рынок — снимите с продажи',
      swapBaked: 'Нельзя обменять амуницию: часть комплекта запечена на NFT — сначала разблокируйте фигуру',
      unitInReserve: 'Эта фигура в запасе — сначала поставьте её в состав',
      tutorialRestartUsed: 'Пройти обучение заново можно только один раз',
      swapSquadReserve: 'Меняются местами фигура состава и фигура из запаса',
      swapOtherFraction: 'Это фигуры разных фракций',
      swapOtherClass: 'Заменить можно только фигуру того же класса',
      unitNotReady: 'Сначала восстановите фигуру',
    pwdWrongCurrent: 'Неверный текущий пароль',
    pwdSameAsOld: 'Новый пароль совпадает со старым',
    nameTaken: 'Это имя занято',
    pwdShort: 'Пароль должен быть не короче {n} символов',
    pwdLong: 'Пароль должен быть не длиннее {n} символов',
    pwdBlank: 'Пароль не может состоять из одних пробелов',
    pwdSameAsName: 'Пароль не должен совпадать с именем игрока',
    nameLen: 'Имя должно быть от {n} до {m} символов',
    noTickets: 'Нет билетов',
    noEnergy: 'Недостаточно энергии',
    tooManyTickets: 'Слишком много билетов за раз',
    badTicketCount: 'Некорректное количество билетов',
    unknownSector: 'Неизвестный сектор колеса',
    userNotFound: 'Пользователь не найден',
    seasonNotFound: 'Турнир не найден',
    seasonRegClosed: 'Регистрация в этот турнир сейчас закрыта',
    seasonFull: 'В турнире не осталось свободных мест',
    seasonOther: 'Вы уже участвуете в другом активном турнире',
    seasonNotIn: 'Вы не участвуете в этом турнире',
    seasonNotPlayed: 'Вы не участвовали в этом турнире',
    mainAccountOnly: 'Действие доступно только с основного аккаунта',
    seasonJoinRetry: 'Не удалось зарегистрироваться, повторите попытку',
    transferWindow: 'Перенос доступен только после завершения турнира',
    noHammer: 'Нет молота кузнеца — разбирайте по одному или купите молот на Рынке',
    nothingPicked: 'Не выбрано ни одного предмета',
    ticketDailyLimit: 'Дневной лимит билетов ({n}) исчерпан',
    ticketsLeftToday: 'Сегодня можно купить не больше {n} билетов',
    seasonEntryTickets: 'Для участия нужно билетов: {n}',
    maxHammers: 'За раз не больше {n} молотов',
    needHammers: 'Нужно молотов: {n}, а есть {m} — купите молоты на Рынке или выберите меньше предметов',
    maxItems: 'За раз не больше {n} предметов',
    unitDeadAmmo: 'Фигура мертва — амуниция заблокирована до оживления',
    unitWounded: 'Фигура ранена — сначала вылечите её',
    unequipFirst: 'Сначала снимите амуницию с фигуры, затем выставляйте',
    soilDrains: 'Почва иссушает ресурсы Короля — навык недоступен',
    questNotFound: 'Задание не найдено',
    questOldDay: 'Это задание прошлого дня',
    questNotDone: 'Задание ещё не выполнено',
    rewardTaken: 'Награда уже получена',
    rerollUsed: 'Бесплатная замена на сегодня использована',
    noOtherQuest: 'Нет другого задания этой сложности',
    chestNotReady: 'Сундук дня ещё не открыт',
    chestTaken: 'Сундук дня уже получен',
    mailNotFound: 'Письмо не найдено',
    choiceUnavailable: 'Выбор недоступен',
    noSpace: 'Нет свободного места — освободите ячейку',
    chestFull: 'Сундук полон',
    noMaterials: 'Недостаточно материалов',
    tooManyRequests: 'Слишком часто — подождите несколько секунд и повторите',
    noGems: 'Недостаточно самоцветов',
    unknownScroll: 'Неизвестный свиток',
    badCount: 'Некорректное количество',
    badMinutes: 'Некорректное количество минут',
    noMinutes: 'Нет минут ускорения',
    noEther: 'Нет эфира',
    noApprenticeScroll: 'Нет свитка подмастерья',
    noMasterScroll: 'Нет свитка мастера',
    chargesFull: 'Заряды уже полные',
    rentOfferGone: 'Это предложение уже недоступно',
    rentOwnFigure: 'Нельзя взять в аренду свою же фигуру',
    rentFigureGone: 'Этой фигуры больше нет у владельца',
    rentTermsChanged: 'Владелец изменил условия — обновите витрину',
    rentFigureHealing: 'Фигура восстанавливается — попробуйте позже',
    rentFigureListed: 'Фигура выставлена на продажу в блокчейне — снимите лот',
    rentNeedsBaked: 'В аренду сдаётся только фигура с запечённым комплектом',
    rentNftOnly: 'В аренду сдаются только NFT-воины',
    rentNoSeason: 'В турнире аренда фигур недоступна',
    rentInMatch: 'Идёт партия — попробуйте после её окончания',
    rentSelfDeal: 'Аренда между связанными аккаунтами недоступна',
    rentNoEarlyReturn: 'Аренда за фиксированную плату досрочно не возвращается — дождитесь конца срока',
    rentReturnHealthy: 'Сначала восстановите фигуру — она возвращается владельцу целой',
    rentLeaveSquad: 'Сначала выведите фигуру из боевого состава',
    rentAlreadyRecalled: 'Фигура уже отозвана и вернётся после партии арендатора',
    rentClosed: 'Эта аренда уже закрыта',
    rentAlreadyRented: 'Эта фигура уже в аренде',
    rentAlreadyOffered: 'Эта фигура уже выставлена в аренду',
    rentAlreadyLent: 'Эта фигура уже сдана',
    rentUnlistFirst: 'Эта фигура выставлена в аренду — сначала снимите предложение',
    rentGearLocked: 'Фигура взята в аренду — её амуницию меняет только собственник',
    rentLent: 'Фигура сдана в аренду',
    rentReturnFirst: 'Фигура сдана в аренду — сначала верните её владельцу',
    rentTermsLocked: 'Условия уже принятой аренды не меняются',
    rentOfferExpired: 'Срок этого предложения истёк',
    rentOfferNotFound: 'Предложение не найдено',
    rentNotFound: 'Аренда не найдена',
    rentOfferCancelled: 'Это предложение уже снято',
    rentOnePayment: 'Выберите одну плату: за сутки ИЛИ процент от заработка',
    rentPercentRange: 'Процент — от 1 до 100',
    rentPriceRange: 'Цена за сутки вне допустимого диапазона',
    rentBadPrice: 'Неверная цена аренды',
    rentBadPercent: 'Неверный процент',
    rentBadDays: 'Неверный срок аренды',
    rentBadTerm: 'Неверный срок',
    rentNeedEnergy: 'Не хватает энергии: нужно {n}',
    rentDaysRange: 'Срок аренды — от 1 до {n} суток',
    rentRecallNeedFull: 'Для возврата нужно вернуть {n} энергии, у вас {m}',
    rentRecallNeed: 'Для возврата нужно вернуть {n} энергии',
    nowhereToUnequip: 'Некуда снять прежнюю амуницию: инвентарь и сундук полны',
    noFractionUnits: 'У игрока нет фигур этой фракции',
    unitNotFound: 'Фигура не найдена',
    unknownFraction: 'Неизвестная фракция',
    boostInMatch: 'Ускорение недоступно во время партии',
    careInMatch: 'Лечение и оживление недоступны во время партии',
    ammoInMatch: 'Нельзя менять амуницию во время партии',
    minMinutes: 'Минимум {n} минут (один самоцвет)',
    maxMinutes: 'За раз не больше {n} минут',
    maxScrolls: 'За раз не больше {n} свитков',
    maxCharges: 'За раз не больше {n} зарядов',
    itemNotFound: 'Предмет не найден',
    itemOnMarket: 'Предмет выставлен на Рынок — сначала снимите его с продажи',
    matchNotFound: 'Партия не найдена',
    unequipFirstItem: 'Сначала снимите предмет',
    unitInvFull: 'Инвентарь фигуры полон',
    wrongSlot: 'Предмет не подходит для этого слота',
    slotBusy: 'Слот занят',
    itemNotEquipped: 'Предмет не надет',
    backItemBad: 'Встречный предмет не подходит: {n}',
    swapWounded: 'Нельзя обменять амуницию: в армии есть невосстановленные фигуры — сначала вылечите или оживите их',
    swapSelf: 'Нельзя поменять фигуру саму с собой',
    swapSameType: 'Менять местами можно только фигуры одного типа',
    nowhereUnequipShort: 'Некуда снять: инвентарь и сундук полны',
    rechargeClassOnly: 'Перезаряжаются только классовые предметы',
    rechargeCurrency: 'Неизвестная валюта перезарядки',
    rechargeNoEnergy: 'Не хватает энергии на перезарядку',
    transferInMatchOnly: 'Передать предмет можно только во время партии',
    itemNotInUnitInv: 'Предмет не в инвентаре фигуры',
    transferSelf: 'Нельзя передать той же фигуре',
    unitNotOnBoard: 'Фигура не на доске',
    unitsNotAdjacent: 'Фигуры не на соседних клетках',
    pickUnitOrFraction: 'Выберите фигуру или фракцию',
    consumablesSeason: 'Расходники общие для всех турниров — торгуйте ими с основного аккаунта',
    marketOffSeason: 'В этом турнире Рынок отключён',
    badPrice: 'Некорректная цена',
    minPrice: 'Минимальная цена — {n} энергии',
    priceRange: 'Цена вне допустимого диапазона',
    badResPrice: 'Некорректная цена в ресурсах',
    unknownPriceRes: 'Неизвестный ресурс в цене',
    priceGemsOnly: 'Ценой могут быть только малые самоцветы',
    badResCount: 'Некорректное количество ресурса',
    resCountRange: 'Количество ресурса вне диапазона',
    itemAlreadyListed: 'Предмет уже выставлен на Рынок',
    unknownRes: 'Неизвестный ресурс',
    sellGemsOnly: 'Продавать можно только малые самоцветы',
    countMin1: 'Количество должно быть не меньше 1',
    notEnoughRes: 'Недостаточно ресурса',
    lotNotFound: 'Лот не найден',
    lotNotYours: 'Это не ваш лот',
    lotClosed: 'Лот уже закрыт',
    chestFullReturn: 'Сундук полон — освободите место, чтобы вернуть предмет',
    lotGone: 'Лот уже продан или снят',
    lotOwn: 'Нельзя купить собственный лот',
    lotOtherWorld: 'Лот из другого мира недоступен (турнир или основной аккаунт)',
    selfTrade: 'Сделка заблокирована: систематическая торговля со связанным аккаунтом',
    notEnoughForBuy: 'Недостаточно ресурсов для покупки',
    lotItemGone: 'Предмет лота недоступен',
    chestFullBuy: 'Сундук полон — освободите место для покупки',
    unknownGoods: 'Неизвестный товар',
    goodsNotFound: 'Товар не найден',
    seasonEnterWindow: 'Войти в турнир можно только во время регистрации или проведения',
    transferResChanged: 'Ресурсы турнирного профиля изменились — повторите перенос',
    transferBalChanged: 'Баланс турнирного профиля изменился — повторите перенос',
    unknownTour: 'Неизвестный обзор',
    unknownTutStep: 'Неизвестный шаг обучения',
    tutStepNotStarted: 'Этот шаг обучения ещё не начат',
    unknownChecklist: 'Неизвестный пункт',
    checklistNotDone: 'Пункт ещё не выполнен',
    unknownAct: 'Неизвестный акт обучения',
    noResForTickets: 'Недостаточно ресурсов для покупки билетов',
    badSpins: 'Некорректное количество вращений',
    maxSpins: 'За один раз можно крутить не больше {n} раз',
    ticketsLessThanSpins: 'Билетов меньше, чем вращений',
    notEnoughResources: 'Недостаточно ресурсов',
    noHospital: 'Нет буста полного исцеления армии',
    nameChars: 'Имя может содержать буквы, цифры, пробел, дефис, точку и подчёркивание',
    matchFinished: 'Партия уже завершена',
    // отказы самой партии (сокет `error`) — показываются плашкой в `/play-web`
    gmOtherFraction: 'Сейчас ход соперника',
    gmNotYourUnit: 'Это не ваша фигура',
    gmUnitNotInMatch: 'Эта фигура не участвует в партии',
    gmCaptureViaFight: 'Взятие фигуры идёт через поединок',
    gmMatchOver: 'Партия уже завершена',
    gmNotYourMatch: 'Это не ваша партия',
    gmNoSession: 'Сессия не найдена — перезайдите в игру',
    gmNotSpectatable: 'Партия недоступна для просмотра',
    gmMaintenance: 'Идёт обслуживание — новые партии временно недоступны',
    gmArmyNotReady: 'Армия не восстановлена: вылечите или оживите фигуры либо дождитесь таймера',
    gmBadMove: 'Так ходить нельзя',
    gmBadCell: 'Недопустимая клетка',
    gmZeroSpeed: 'У этой фигуры не осталось инициативы',
    gmNoAttackTarget: 'Здесь некого атаковать',
    gmNoTargetOnBoard: 'На доске нет цели',
    gmNoFightNow: 'Сейчас нельзя начать бой',
    gmSkillKingOnly: 'Навык есть только у Короля',
    gmKingNoSkill: 'У этого Короля нет активного навыка',
    gmAbilityKingOnly: 'Классовую способность на доске применяет только Король',
    gmNoSkillNow: 'Сейчас нельзя применить навык',
    gmNoAbilityNow: 'Сейчас нельзя применить способность',
    gmSkillNeedsTarget: 'Выберите цель навыка',
    gmAbilityNeedsTarget: 'Выберите цель способности',
    gmBadSkillTarget: 'Недопустимая цель навыка',
    gmTargetMustBeAlly: 'Цель навыка должна быть союзной',
    gmTargetMustBeEnemy: 'Цель навыка должна быть вражеской',
    gmImmuneRoyals: 'Король и Ферзь врага невосприимчивы к магии',
    gmNoClassAbility: 'У этой фигуры нет классовой способности',
    gmCloakedCannotAttack: 'Фигура под Плащом не может атаковать',
    gmExtraTurnKnightOnly: 'Второй ход делает только Конь, применивший «Ускорение»',
    gmPetrified: 'Фигура обездвижена: у неё почти не осталось здоровья',
    gmCloakedCannotBeHit: 'Эту фигуру нельзя атаковать: она под Плащом',
    gmSpellNotInBook: 'Это заклинание книге недоступно',
    gmTargetTooFar: 'Цель слишком далеко',
    gmSpellTargetAlly: 'Цель заклинания должна быть союзной',
    gmSpellTargetEnemy: 'Цель заклинания должна быть вражеской',
    gmAbilityTargetOutOfFight: 'Цель способности вне боя',
    gmNoSkillResources: 'Недостаточно ресурсов для навыка',
    gmSkillFailed: 'Навык не применился — не хватило ресурсов',
    gmOtherUnitTurn: 'Сейчас ход другой фигуры',
    gmAlreadyActed: 'Это действие уже сделано в этом ходу',
    gmTargetInvisible: 'Цель невидима',
    gmWallBlocks: 'Ваш подкласс блокирован Стеной — атакуйте Стену',
    gmWallOnCell: 'Клетку перекрывает Стена',
    gmWallFar: 'Стену можно поставить только на соседнюю клетку',
    gmCellBusy: 'Клетка занята фигурой',
    gmWallHere: 'На этой клетке уже стоит Стена',
    gmWarriorAttackThrough: 'Воин не может атаковать через фигуру',
    gmWarriorSkillThrough: 'Воин не может применить навык через фигуру',
    gmSeasonNotStarted: 'Турнир ещё не начался — партии откроются в дату старта',
    gmSeasonOver: 'Турнир завершён — итоги подведены, новые партии недоступны',
    gmSeasonClosed: 'Партии турнира сейчас недоступны',
    gmAbCellNeeded: 'Выберите клетку поля',
    gmAbNoCharges: 'Заряды способности исчерпаны',
    gmAbCasterOffField: 'Кастер вне боевого поля',
    gmAbCellTaken: 'Клетка занята',
    gmAbBadSpellTarget: 'Недопустимая цель заклинания',
    gmAbUnknownSpell: 'Неизвестное заклинание',
    gmAbOwnWall: 'Нельзя атаковать свою Стену',
    gmAbFightOnly: 'Способность доступна только в бою',
    gmAbWallOwnHalf: 'Стену можно поставить только на своей половине поля',
    gmAbNoWall: 'Стены на поле нет',
    gmAbNoClassItem: 'У фигуры нет классового предмета',
    gmAbNoAbility: 'У фигуры нет классовой способности',
    gmAbTargetNotFound: 'Цель способности не найдена',
    gmAbNotOnWall: 'Эту способность нельзя применить к Стене',
    playerNotFound: 'Игрок не найден',
    rentDeleteInMatch: 'У игрока идёт партия с арендованной фигурой — удаление возможно после её завершения',
  },
  tgWelcome: {
    title: 'Добро пожаловать в ChessZombies',
    text: 'Вы открыли игру из Telegram. Создать нового игрока или войти в аккаунт, который у вас уже есть?',
    newPlayer: 'Я новый игрок',
    haveAccount: 'У меня уже есть аккаунт',
    hint: 'Если войти в существующий аккаунт, Telegram привяжется к нему — дальше игра будет открываться сразу, без пароля.',
    failed: 'Не удалось создать игрока. Откройте игру из Telegram заново.',
  },
  rarity: {
    common: 'Обычная',
    rare: 'Редкая',
    super_rare: 'Супер редкая',
    unique: 'Уникальная',
    epic: 'Эпическая',
    commonM: 'Обычный',
    rareM: 'Редкий',
    super_rareM: 'Супер-редкий',
    uniqueM: 'Уникальный',
    epicM: 'Эпический',
    commonLow: 'обычная',
    rareLow: 'редкая',
    super_rareLow: 'супер-редкая',
    uniqueLow: 'уникальная',
    epicLow: 'эпическая',
  },
};
